/* eslint-disable */
import React, { Component } from 'react'
import StoryDetails from './StoryDetails'
import LiveNewsDetails from './LiveNewsDetails'
import LiveUpdates from './LiveUpdates'
import CoverStoryDetails from './CoverStoryDetails'
import SlideShowContent from './SlideShowContent'
import ListUsersInRole from '../../Services/Queries/ListUsersInRole'
import GetContentCreatorsAndPlannersList from '../../Services/Queries/GetContentCreatorsAndPlannersList'
import GetListHashTagsofUserAndGlobal from '../../Services/Queries/GetListHashTagsofUserAndGlobal'
import GeneralOptions from './GeneralOptions'
import Preview from './Preview'
import GetYousayInAppUser from '../../Services/Queries/GetYousayInAppUser'
import GetYouSayIdDetails from '../../Services/Queries/GetYouSayIdDetails'
import CreateContentService from '../../Services/Mutations/CreateContent'
import CreateUserHashtag from '../../Services/Mutations/CreateUserHashtag'
import UpdateContent from '../../Services/Mutations/UpdateContent'
import { CategoriesData } from './CategoriesData'
import { Button, Modal } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import { Auth } from 'aws-amplify'
import _ from 'lodash'
import { KTColors } from '../Constants/KTColors'
import {
	heightPercentageToDP,
	widthPercentageToDP,
} from '../../Utils/ResponsiveScreen'
import CreateAs from './CreateAs'
import McqContent from './McqContent'
import Toast from 'react-bootstrap/Toast'
import Alert from 'react-bootstrap/Alert'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import PollContent from './PollDetails'
import AwsConfig from '../../Config/AwsConfig'
import InAppMessage from './InAppMessage'
import DynamicButtonValidations from './DynamicButtonValidations'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { decode as base64_decode, encode as base64_encode } from 'base-64'
import PointsTable from './PointsTable'
import { withRouter } from 'react-router-dom'
import ClearImageCloudFrontCache from '../../Services/Mutations/clearImageCloudFrontCache'
import {
	answersInfoValidation,
	fsValidation,
	GetCoverStoryType,
	getEditContentSelectedCategory,
	getFormattedImages,
	getSelectedDate,
	getSelectedItem,
	GetSlideShowPagesData,
	GetStoryCotentData,
	getWordpressCategoryIds,
	GetWordPressInfo,
	inAppBrowserChangeValidation,
	InAppMessageValidations,
	mcqChangeValidations,
	onlyCoverValidation,
	pollInfoValidation,
	StickyPostValidations,
	storyChangeValidations,
	GetLiveNewsContentData,
} from './ConstantFunctions'
import { autoExpireOptions, coverStoryTypes } from '../Data/StaticData'
import GetContentCategories from '../../Services/Queries/GetContentCategories'
import ApproveCreatedContent from './ApproveCreatedContent'
import MandatoryValidations from './SubComponents/MandatoryValidations'

const styles = {
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',
	},
}

class Content extends Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}

	constructor(props) {
		super(props)
		this.state = {
			loggedInUserId: '',
			contentCreated: false,
			approveCreatedContentModal: false,
			syncToWordpress: true,
			disableSyncToWordPress: false,
			wordPressPostStatus: 'draft',
			wpTwitterLink: '',
			wpInstagramLink: '',
			wpYoutubeLink: '',
			featuredImageId: '',
			WPCatIds: [],
			WPTagIds: [],
			wordPressInfo: {},
			permalink: '',
			creationStatus: '',
			contentModalVisible: false,
			sendPNWithImage: true,
			render: false,
			selectedContentType: '',
			posts: [],
			contentTypeOptions: [
				{
					item: 'Story',
					id: 1,
				},
				{
					item: 'ShortByte',
					id: 2,
				},
				{
					item: 'CoverStory',
					id: 3,
				},
				{
					item: 'Mcq',
					id: 4,
				},
				{
					item: 'SlideShow',
					id: 5,
				},
				{
					item: 'Poll',
					id: 6,
				},
				{
					item: 'liveCricketScore',
					id: 7,
				},
				{
					item: 'cricketPointsTable',
					id: 6,
				},
				{
					item: 'liveNews',
					id: 8,
				},
			],
			contentLanguageOptions: [
				{
					label: 'Telugu',
					value: 'Te',
					id: 0,
				},
				{
					label: 'English',
					value: 'En',
					id: 1,
				},
			],

			genderOptions: [
				{ genderType: 'both', img: 'both_men_women', id: 1 },
				{ genderType: 'Male', img: 'only_men', id: 2 },
				{ genderType: 'Female', img: 'only_women', id: 3 },
			],
			textColorOptions: [
				{ item: 'white', id: 1, value: '#ffffff' },
				{ item: 'black', id: 2, value: '#000000' },
				{ item: 'grey', id: 3, value: '#bdbdbd' },
			],
			sendPushNotification: false,
			showTitle: false,
			showTitleBackground: false,
			files: [],
			file: '',
			imagePreviewUrl: [],
			selectedContentImages: [],
			title: '',
			description: '',
			contentSelectedLangVal: 'Te',
			createAs: 'user',
			selectedCoverStoryType: {
				item: 'Flip To Story',
				id: 1,
			},
			selectedContributor: {},
			selectedContentPlanner: {},
			selectedTextColor: '#ffffff',
			link: '',
			linkText: '',
			invalidURL: false,
			suggestions: [],
			newTagsArr: [],
			tagsWithTypeArr: [],
			tagsArr: [],
			tagsWithGenderArr: [],
			tags: { tag: '', tagsArray: [] },
			tagValue: '',
			canEditTags: true,
			coverStoryTypes,
			isFlipped: false,
			allowDownloads: false,
			createInBoxOffice: true,
			contentTitlePosition: null,
			backGroundTitle: '',
			copyRight: false,
			shareImage: false,
			copyRightText: '',
			archivalDate: null,
			pnTitle: '',
			allowShare: true,
			allowComments: true,
			isCopyRightAccepted: false,
			selectedGenderType: 'both',
			sendPushNotification: false,
			contentLang: 'English',
			displayQuesLangDropdown: false,
			editContent: false,
			selectedImagePath: [],
			sendPN: false,
			selectedContentType: 'Story',
			contentDetails: {},
			storyDetails: {},
			livenewsDetails: {},
			mcqDetails: {},
			coverStoryDetails: {},
			pollDetails: {},
			changeToType: 'Story',
			changeToLanguage: 'Te',
			isGeneralOptionsEdited: false,
			getDataFromChilds: false,
			enableCreateContent: false,
			autoExpireOptions,
			selectedAutoExpireDate: {
				value: 'None',
				days: 0,

				id: 1,
			},
			selectedAutoDeleteDate: {
				value: 'None',
				days: 0,

				id: 1,
			},
			scheduledDate: new Date(),
			pollClosingDate: new Date(),
			contentMainCategory: 'news',
			sendPNWithBigText: false,
			bigTextTitle: '',
			categories: CategoriesData,
			selectedCategory: '',
			modalVisible: false,
			previewData: null,
			selectedTargetAreas: [],
			selectedPnPriority: 'regularTopic',
			contentID: '',
			stickyPost: false,
			positionFromTop: '',
			stickyEndDateTime: new Date(
				new Date().setHours(new Date().getHours() + 12),
			),
			showSticky: 'Unlimited',
			stickyTargetImpressions: 10,
			isInAppMessage: false,
			inAppMessageDetails: {},
			selectedPeopleList: [],
			userDetails: {},
			pushRankUpTo: 30,
			pushRankTo: 1,
			missingSubContentMandatoryFields: false,
			missingMandatoryFields: false,
			updateErrorValidations: false,
			matchKey: '',
			tournamentKey: '',
			associationKey: '',
			teamsShortCodes: [],
			addTargetAreasToWP: false,
			targetAreaV2: [],
			addNewsToCategory: false,
			newsCategoryId: '',
			categories: [],
			targetAreasList: [],
			createdContentData: {},
		}
		this.contentImage = ''
		this.contentImages = []
		this.slideShow = {}
		this.coverStory = {
			flipToStoryDetails: {},
			onlyCoverDetails: {},
			inAppBrowserDetails: {},
		}
		this.story = {}
		this.liveNews = []
		this.liveCricket = {}
		this.cricketPointsTable = {}
		this.mcq = {}
		this.coverStorySubType = 'FlipToStory'
		this.videoDetails = {}
		this.poll = {}
		this.contentStatus = ''
		this.isPreviouslyCampaign = false
		this.InAppMessageChild = React.createRef()
		this.isPreviouslyStickyPost = false
		this.missingMandatoryFields = true
		this.missingSubContentMandatoryFields = true
	}

	storyChangeValidations = story => {
		const { contentSelectedLangVal } = this.state
		const validation = storyChangeValidations(story, contentSelectedLangVal)
		return validation
	}

	mcqChangeValidations = mcq => {
		const { contentSelectedLangVal } = this.state
		const validation = mcqChangeValidations(mcq, contentSelectedLangVal)
		return validation
	}

	slideShowChangeValidations = slideShow => {
		const pages = slideShow.pages && slideShow.pages.length > 0
		return pages
	}

	pollChangeValidations = poll => {
		const { contentSelectedLangVal } = this.state
		const pollTitle = poll && poll[`pollTitle_${contentSelectedLangVal}`] != ''
		const pollDescription =
			poll && poll[`pollDescription_${contentSelectedLangVal}`] != ''
		const pollImage = poll.pollImage && poll.pollImage.length > 0
		const pollInfo = poll.pollInfo && poll.pollInfo.length > 0
		return poll
	}

	flipToStoryChangeValidataion = flipToStory => {
		const { contentSelectedLangVal } = this.state
		const validation = fsValidation(flipToStory, contentSelectedLangVal)
		return validation
	}

	onlyCoverChangeValidataion = onlyCover => {
		const { contentSelectedLangVal } = this.state
		const validation = onlyCoverValidation(onlyCover, contentSelectedLangVal)
		return validation
	}

	inAppBrowserChangeValidation = inAppBrowser => {
		const { contentSelectedLangVal } = this.state
		const validation = inAppBrowserChangeValidation(
			inAppBrowser,
			contentSelectedLangVal,
		)
		return validation
	}

	checkValidationsForChangeContent = childType => {
		const { story, mcq, slideShow, poll } = this
		if (childType == 'Story' || childType == 'ShortByte') {
			return this.storyChangeValidations(story)
		}

		if (childType == 'CoverStory') {
			const {
				flipToStoryDetails,
				onlyCoverDetails,
				inAppBrowserDetails,
			} = this.coverStory
			return this.coverStorySubType == 'FlipToStory'
				? this.flipToStoryChangeValidataion(flipToStoryDetails)
				: this.coverStorySubType == 'OnlyCover'
					? this.onlyCoverChangeValidataion(onlyCoverDetails)
					: this.coverStorySubType == 'InAppBrowser'
						? this.inAppBrowserChangeValidation(inAppBrowserDetails)
						: false
		}

		if (childType == 'Mcq') {
			return this.mcqChangeValidations(mcq)
		}

		if (childType == 'SlideShow') {
			return this.slideShowChangeValidations(slideShow)
		}

		if (childType == 'Poll') {
			return this.pollChangeValidations(poll)
		}

		return false
	}

	verifyLink = link => {
		const regex1 = new RegExp(
			'^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?',
		)
		return !regex1.test(link)
	}

	checkAnswersInfoValidations = () => {
		const { answersInfo } = this.mcq
		const { contentSelectedLangVal } = this.state
		const validation = answersInfoValidation(
			answersInfo,
			contentSelectedLangVal,
		)
		return validation
	}

	checkpollInfoValidations = () => {
		const { pollInfo } = this.poll
		const { contentSelectedLangVal } = this.state
		const validation = pollInfoValidation(pollInfo, contentSelectedLangVal)
		return validation
	}

	resetGeneralOption = () => {
		this.setState({
			selectedContentType: 'Story',
			contentLang: 'English',
			allowShare: true,
			createInBoxOffice: true,
			allowComments: true,
			sendPNWithImage: true,
			// scheduleTime: moment(new Date()).unix(),
			showDatePicker: false,
			showTimePicker: false,
			modalVisible: false,
			isGeneralOptionsEdited: false,
			generalOptionsExpanded: false,
			pnTitle: '',
			pnDescription: '',
			bigTextTitle: '',
		})
	}

	changeContentType = async (currentType, type) => {
		const { isGeneralOptionsEdited } = this.state
		if (this.props.editContent) {
			this.setState({ contentModalVisible: true })
		} else {
			if (type == 'ShortByte') {
				this.setState({ syncToWordpress: false })
			}

			if (currentType != type) {
				if (
					isGeneralOptionsEdited ||
					this.checkValidationsForChangeContent(currentType)
				) {
					this.setState({ modalVisible: true, changeToType: type })
				} else {
					this.resetGeneralOption()
					this.setState({ selectedContentType: type })
				}
			}
		}
	}

	changeContentLanguage = async (currentLanguage, language) => {
		const { isGeneralOptionsEdited, selectedContentType } = this.state
		if (currentLanguage != language) {
			if (
				isGeneralOptionsEdited ||
				this.checkValidationsForChangeContent(selectedContentType)
			) {
				this.setState({
					modalVisible: true,
					changeToLanguage: language,
					syncToWordpress: language != 'En',
					contentSelectedLangVal: language,
				})
			} else {
				this.setState({ contentSelectedLangVal: language })
			}
		}
	}

	stripTypenames = value => {
		if (Array.isArray(value)) {
			return value.map(this.stripTypenames)
		}

		if (value !== null && typeof value === 'object') {
			const newObject = {}
			for (const property in value) {
				if (property !== '__typename') {
					newObject[property] = this.stripTypenames(value[property])
				}
			}

			return newObject
		}

		return value
	}

	getStoryContentData = storyData => {
		const { storyCardImages, storyYoutubeImages } = storyData
		const data = storyData
		const storyContentData = GetStoryCotentData(
			data,
			storyCardImages,
			storyYoutubeImages,
		)
		return storyContentData
	}

	getLiveNewsContentData = liveNewsData => {
		liveNewsData.map((item, index) => {
			const { liveNewsImages, liveNewsYoutubeImages } = item
			item = GetLiveNewsContentData(
				item,
				liveNewsImages,
				liveNewsYoutubeImages,
			)
		})
		return liveNewsData
	}

	getFormattedData = async (editContent, contentMetaInfo) => {
		this.storyDetails = contentMetaInfo.storyDetails
		if (this.props.duplicateContent) {
			Object.keys(this.storyDetails).map((item, index) => {
				if (item.includes('storyTitle')) {
					this.storyDetails[item] = ''
				}

				if (item.includes('storyCardDescription')) {
					this.storyDetails[item] = ''
				}
			})
		}

		this.coverStory = {
			flipToStoryDetails:
				contentMetaInfo &&
					contentMetaInfo.coverStoryDetails &&
					contentMetaInfo.coverStoryDetails.flipToStoryDetails
					? contentMetaInfo.coverStoryDetails.flipToStoryDetails
					: {},
			onlyCoverDetails:
				contentMetaInfo &&
					contentMetaInfo.coverStoryDetails &&
					contentMetaInfo.coverStoryDetails.onlyCoverDetails
					? contentMetaInfo.coverStoryDetails.onlyCoverDetails
					: {},
			inAppBrowserDetails:
				contentMetaInfo &&
					contentMetaInfo.coverStoryDetails &&
					contentMetaInfo.coverStoryDetails.inAppBrowserDetails
					? contentMetaInfo.coverStoryDetails.inAppBrowserDetails
					: {},
		}
		this.story =
			contentMetaInfo && contentMetaInfo.storyDetails
				? await this.getStoryContentData(contentMetaInfo.storyDetails)
				: {}
		this.mcq =
			contentMetaInfo && contentMetaInfo.mcqDetails
				? contentMetaInfo.mcqDetails
				: {}
		this.poll =
			contentMetaInfo && contentMetaInfo.pollDetails
				? contentMetaInfo.pollDetails
				: {}
		const coverStoryType =
			this.coverStory.flipToStoryDetails.coverStoryTitle != null
				? 'FlipToStory'
				: this.coverStory.onlyCoverDetails.coverStoryTitle != null
					? 'OnlyCover'
					: 'InAppBrowser'
		const coverStorySubType = editContent
			? coverStoryType
			: this.coverStorySubType
		this.coverStory.coverStoryType = coverStorySubType
		this.coverStorySubType = coverStorySubType
		this.slideShow =
			contentMetaInfo && contentMetaInfo.slideShowDetails
				? contentMetaInfo.slideShowDetails
				: {}
		this.liveCricket =
			contentMetaInfo && contentMetaInfo.liveCricketDetails
				? contentMetaInfo.liveCricketDetails
				: {}
		this.cricketPointsTable =
			contentMetaInfo && contentMetaInfo.cricketPointsTableDetails
				? contentMetaInfo.cricketPointsTableDetails
				: {}
		this.liveCricket.matchKey = this.props.contentDetails.matchKey
			? this.props.contentDetails.matchKey
			: ''
		this.cricketPointsTable.tournamentKey = this.props.contentDetails
			.tournamentKey
			? this.props.contentDetails.tournamentKey
			: ''
		this.cricketPointsTable.associationKey = this.props.contentDetails
			.associationKey
			? this.props.contentDetails.associationKey
			: ''
		this.liveNews =
			contentMetaInfo && contentMetaInfo.liveNewsSectionDetails
				? await this.getLiveNewsContentData(
					contentMetaInfo.liveNewsSectionDetails,
				)
				: {}
	}

	getTagsArray = contentDetails => {
		const tagsArr = []
		const tags = []
		const tagsWithTypeArr = []
		if (contentDetails.creatorVideoHashTag1) {
			tags.push(contentDetails.creatorVideoHashTag1)
			tagsArr.push(contentDetails.creatorVideoHashTag1)
			tagsWithTypeArr.push(contentDetails.creatorVideoHashTag1AndType)
		}

		if (contentDetails.creatorVideoHashTag2) {
			tags.push(contentDetails.creatorVideoHashTag2)
			tagsArr.push(contentDetails.creatorVideoHashTag2)
			tagsWithTypeArr.push(contentDetails.creatorVideoHashTag2AndType)
		}

		if (contentDetails.creatorVideoHashTag3) {
			tags.push(contentDetails.creatorVideoHashTag3)
			tagsArr.push(contentDetails.creatorVideoHashTag3)
			tagsWithTypeArr.push(contentDetails.creatorVideoHashTag3AndType)
		}

		if (contentDetails.creatorVideoHashTag4) {
			tags.push(contentDetails.creatorVideoHashTag4)
			tagsArr.push(contentDetails.creatorVideoHashTag4)
			tagsWithTypeArr.push(contentDetails.creatorVideoHashTag4AndType)
		}

		return [tags, tagsArr, tagsWithTypeArr]
	}

	getWordpressCategoryIds = wordPressInfo => {
		let catIds = []
		catIds = getWordpressCategoryIds(wordPressInfo)
		return catIds
	}

	getselectedCategories = () => {
		const { selectedCategory } = this.state
		const { contentDetails } = this.props
		if (selectedCategory != '') {
			let selectedItem = ''
			selectedItem = getSelectedItem(selectedCategory)
			return selectedItem
		}

		let selectedItem = ''
		selectedItem = getEditContentSelectedCategory(contentDetails)
		// const selectedItem = categoryData + levelData + sublevelData
		return selectedItem
	}

	getSelectedDate = days => {
		const selectedDate = getSelectedDate(days)
		return selectedDate
	}

	getScheduledDateObject = dateValue => {
		const utcSeconds = dateValue
		const scheduledDate = new Date(0) // The 0 there is the key, which sets the date to the epoch
		scheduledDate.setUTCSeconds(utcSeconds)
		const dateObj = new Date(scheduledDate)
		return scheduledDate
	}

	changeContentIDValue = async () => {
		let contentIDVal = ''
		contentIDVal = await uuidv4()
		this.setState({
			contentID: contentIDVal,
		})
	}

	resetDuplicateContentData = () => {
		this.changeContentIDValue()
		this.setState({
			createInBoxOffice: true,
			stickyPost: false,
			positionFromTop: '',
			stickyEndDateTime: new Date(
				new Date().setHours(new Date().getHours() + 12),
			),
			showSticky: 'Unlimited',
			stickyTargetImpressions: 10,
			isInAppMessage: false,
			inAppMessageDetails: {},
			pushRankUpTo: 30,
			pushRankTo: 1,
			sendPushNotification: false,
			selectedPnPriority: 'regularTopic',
			pnTitle: '',
			pnDescription: '',
			bigTextTitle: '',
			sendPNWithImage: true,
		})
	}

	getWordPressInfo = wordPressInfo => {
		const info = GetWordPressInfo(this.props.duplicateContent, wordPressInfo)
		return info
	}

	async componentDidMount() {
		const { duplicateContent } = this.props
		const userDetailsInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userDetails = await GetUserPermissions(userDetailsInput)
		console.log(userDetails, 'userDetails')
		// get all content creators or planners list

		const plannersList = await GetContentCreatorsAndPlannersList()
		console.log(plannersList, 'plannersList=========')

		const input = { roleName: 'ContentTeam' }
		const usersList = await ListUsersInRole(input)
		const items = usersList && usersList.items ? usersList.items : []
		// get general options data
		const data = await GetContentCategories()
		console.log(data, 'data in GetContentCategories')

		this.setState({
			newsCategoryId: data.newsCategoryWPID,
			categories: data.categoriesConfig,
			targetAreasList: data.targetAreaV2categoriesConfig
				? data.targetAreaV2categoriesConfig
				: [],
			usersList: items,
			plannersList:
				plannersList && plannersList.items ? plannersList.items : [],
			userDetails,
			loggedInUserId: userDetails.PK,
		})
		const { contentSelectedLangVal } = this.props
		const details = this.props.contentDetails
		const contentDetails = this.stripTypenames(details)
		const { editContent } = this.props
		if (!editContent) {
			if (
				this.state.contentSelectedLangVal == 'En' ||
				this.state.changeToLanguage == 'En'
			) {
				this.setState({ syncToWordpress: false })
			}
		}

		if (editContent) {
			const { contentMetaInfo } = contentDetails
			await this.getFormattedData(editContent, contentMetaInfo)
			const tagsArr = await this.getTagsArray(contentDetails)
			const editTags = tagsArr[0].length != 4
			const tags = {
				tag: '',
				tagsArray: tagsArr[0],
			}
			if (contentMetaInfo?.contentImages?.length > 0) {
				const contentImages = []
				contentMetaInfo.contentImages.map(item => {
					const contentimagesindex = item.indexOf('public')
					if (contentimagesindex > 0) {
						const strippedImage = item.substring(item.indexOf('public'))
						contentImages.push(strippedImage)
					}
				})
				this.contentImages =
					contentImages.length > 0
						? contentImages
						: contentMetaInfo.contentImages
			}

			let planner = ''
			if (contentDetails.contentPlanner) {
				const plannerIndex = plannersList.items.findIndex(
					item => item.PK == contentDetails.contentPlanner,
				)
				if (plannerIndex != -1) {
					planner = plannersList.items[plannerIndex]
				}
			}

			// To Do var index = contentMetaInfo.link ? contentMetaInfo.link.indexOf('?') : -1
			if (contentMetaInfo) {
				this.contentImage = contentMetaInfo.contentImage
					? contentMetaInfo.contentImage.substring(
						contentMetaInfo.contentImage.indexOf('public'),
					)
					: ''
				let loggedInUserDetails = {}

				const loggedInUserEmail = Auth.user.attributes
					? Auth.user.attributes.email
					: ''
				if (loggedInUserEmail) {
					const emailParams = loggedInUserEmail.split('@')
					const loggedInUserHandle = '@' + emailParams[0]
					const handleInput = { YouSayID: loggedInUserHandle }
					loggedInUserDetails = await GetYouSayIdDetails(handleInput)
				}

				console.log(contentDetails, 'contentDetailscontentDetails')
				this.contentStatus = contentDetails.SK
				this.isPreviouslyCampaign =
					Boolean(contentDetails.isInAppMessage != undefined &&
						contentDetails.isInAppMessage != null &&
						contentDetails.isInAppMessage &&
						contentDetails.stickyPost != undefined &&
						contentDetails.stickyPost != null &&
						!contentDetails.stickyPost)
				this.isPreviouslyStickyPost =
					contentDetails.stickyPost != undefined &&
						contentDetails.stickyPost != null
						? contentDetails.stickyPost
						: false
				const createdAs =
					contentDetails.createdAs == 'YouSay Editor'
						? 'YouSay Editor'
						: contentDetails.createdAs == loggedInUserDetails.name
							? 'user'
							: 'other'
				const selectedContributor = {
					name: createdAs == 'other' ? contentDetails.createdAs : '',
				}

				let wpcategoryIDs = []
				const wordpressInfoExists =
					contentDetails.wordPressInfo &&
					Object.keys(contentDetails.wordPressInfo).length > 0
				if (wordpressInfoExists) {
					wpcategoryIDs = await this.getWordpressCategoryIds(
						contentDetails.wordPressInfo,
					)
				}

				const contentType =
					contentDetails.storyType && contentDetails.storyType != ''
						? contentDetails.storyType
						: contentDetails.contentType
				const contentTargetAreas = contentDetails.targetAreaV2
				const selectedTargetAreasArr = []
				if (contentTargetAreas) {
					contentTargetAreas.map((targetArea, index) => {
						const targetAreaIndex = this.state.targetAreasList.findIndex(
							item => item.heading == targetArea,
						)
						if (targetAreaIndex != -1) {
							selectedTargetAreasArr.push(
								this.state.targetAreasList[targetAreaIndex],
							)
						}
					})
				}

				// const selectedTargetAreasArr = contentDetails.targetAreaV2
				this.setState({
					addTargetAreasToWP: contentDetails.addedTargetAreaCategories,
					addNewsToCategory: contentDetails.addedNewsCategories,
					newsCategoryId: contentDetails.newsCategoriesArr,
					targetAreaV2: contentDetails.targetAreaV2,
					selectedTargetAreas: selectedTargetAreasArr,
					selectedContentPlanner: planner,
					syncToYousaytv: Boolean(contentDetails.syncToYousaytv),
					matchKey: contentDetails.matchKey ? contentDetails.matchKey : '',
					tournamentKey: contentDetails.tournamentKey
						? contentDetails.tournamentKey
						: '',
					associationKey: contentDetails.associationKey
						? contentDetails.associationKey
						: '',
					featuredImageId: wordpressInfoExists
						? contentDetails.wordPressInfo.wordPressMediaID
							? parseInt(contentDetails.wordPressInfo.wordPressMediaID)
							: ''
						: '',
					syncToWordpress:
						this.state.selectedContentType == 'ShortByte' ? false : !this.props.duplicateContent && contentDetails.syncToYousaytv

							? true
							: contentSelectedLangVal != 'En',
					permalink:
						!this.props.duplicateContent && wordpressInfoExists
							? contentDetails.wordPressInfo.wordPressPermaLink
							: '',
					WPTagIds: wordpressInfoExists
						? contentDetails.wordPressInfo.wordPressTagIDs
						: [],
					WPCatIds: wpcategoryIDs,
					wordPressPostStatus: wordpressInfoExists
						? contentDetails.wordPressInfo.wordPressPostStatus
						: 'draft',
					wordPressInfo: this.getWordPressInfo(contentDetails.wordPressInfo),
					selectedPeopleList: contentDetails.peopleValues,
					selectedAutoDeleteDate: this.getSelectedDate(
						contentDetails.selectedAutoDeleteDate,
					),
					selectedAutoExpireDate: this.getSelectedDate(
						contentDetails.selectedAutoExpireDate,
					),
					contentSelectedLangVal: this.props.contentSelectedLangVal,
					generalOptionsExpanded: true,
					contentMainCategory: contentDetails.contentMainCategory,
					contentLanguage: contentDetails.contentLanguage,
					editContent,
					createdAs: contentDetails.createdAs,
					creatorUUID: contentDetails.creatorUUID,
					selectedContentType: contentType,
					sendPushNotification: contentDetails.sendPushNotification,
					bigTextTitle:
						contentDetails[`bigTextTitle_${contentSelectedLangVal}`],
					pnTitle: contentDetails[`pnTitle_${contentSelectedLangVal}`],
					selectedPnPriority: contentDetails.pnPriority
						? contentDetails.pnPriority
						: 'low',
					pnDescription:
						contentDetails[`pnDescription_${contentSelectedLangVal}`],
					sendPNWithImage: contentDetails.sendPNWithImage,
					selectedCategory: this.getselectedCategories(),
					scheduledDate: await this.getScheduledDateObject(
						contentDetails.scheduledTime,
					),
					scheduledTime: contentDetails.scheduledTime,
					contentLang: contentDetails.contentLanguage,
					allowShare: contentDetails.allowShare,
					createInBoxOffice: contentDetails.createInBoxOffice,
					allowComments: contentDetails.allowComments,
					tagsWithGenderTarget: contentDetails.tagsWithGenderTarget,
					tags,
					editTags,
					tagsWithTypeArr: tagsArr[2],
					tagsArr: tagsArr[1],
					scheduleTime: contentDetails.scheduledTime,
					contentID: contentDetails.PK,
					stickyPost:
						contentDetails.stickyPost != undefined &&
							contentDetails.stickyPost != null
							? contentDetails.stickyPost
							: false,
					showSticky:
						contentDetails.showSticky != undefined &&
							contentDetails.showSticky != null
							? contentDetails.showSticky
							: 'Unlimited',
					positionFromTop:
						contentDetails.tempPositionFromTop != undefined &&
							contentDetails.tempPositionFromTop != null
							? contentDetails.tempPositionFromTop
							: contentDetails.positionFromTop != undefined &&
								contentDetails.positionFromTop != null
								? contentDetails.positionFromTop
								: '',
					stickyEndDateTime:
						contentDetails.stickyEndDateTime != undefined &&
							contentDetails.stickyEndDateTime != null
							? parseInt(contentDetails.stickyEndDateTime) * 1000
							: this.state.stickyEndDateTime,
					stickyTargetImpressions:
						contentDetails.stickyTargetImpressions != undefined &&
							contentDetails.stickyTargetImpressions != null
							? contentDetails.stickyTargetImpressions
							: '',
					isInAppMessage:
						contentDetails.isInAppMessage != undefined &&
							contentDetails.isInAppMessage != null
							? contentDetails.isInAppMessage
							: this.state.contentDetails.isInAppMessage,
					inAppMessageDetails:
						contentDetails.inAppMessageDetails != undefined &&
							contentDetails.inAppMessageDetails != null &&
							Object.keys(contentDetails.inAppMessageDetails).length > 0
							? contentDetails.inAppMessageDetails
							: this.state.inAppMessageDetails,
					pushRankTo:
						contentDetails.pushRankTo != undefined &&
							contentDetails.pushRankTo != null
							? contentDetails.pushRankTo
							: this.state.pushRankTo,
					pushRankUpTo:
						contentDetails.pushRankUpTo != undefined &&
							contentDetails.pushRankUpTo != null
							? contentDetails.pushRankUpTo
							: this.state.pushRankUpTo,
				})
			}

			const createContentValidation = this.checkCreateContentValidations()
			if (this.state.enableCreateContent != createContentValidation) {
				this.setState({ enableCreateContent: createContentValidation })
			}

			if (duplicateContent) {
				this.resetDuplicateContentData()
			}
		} else {
			this.changeContentIDValue()
		}
	}

	handlebigTextTitle = e => {
		this.setState({ bigTextTitle: e.target.value })
	}

	handlePNTitle = e => {
		const pnTitle = e.target.value.substring(0, 45)
		this.setState({ pnTitle })
	}

	handlePNDescription = e => {
		const pnDescription = e.target.value.substring(0, 240)
		this.setState({ pnDescription: e.target.value })
	}

	handleTargetAreas = val => {
		this.setState({ selectedTargetAreas: val })
	}

	handleClick(e) {
		e.preventDefault()
		this.setState(prevState => ({ isFlipped: !prevState.isFlipped }))
	}

	handleGenderTarget = val => {
		this.setState({ selectedGenderType: val })
	}

	handleAllowShare = e => {
		this.setState({ allowShare: e.target.checked })
	}

	handleAllowDownloads = e => {
		this.setState({ allowDownloads: e.target.checked })
	}

	handleCreateInBoxOffice = e => {
		this.setState({ createInBoxOffice: e.target.checked })
	}

	handleChangeStickyPost = e => {
		this.setState(
			{
				stickyPost: e.target.checked,
				isInAppMessage: e.target.checked,
				createInBoxOffice: !e.target.checked,
			},
			() => {
				if (this.state.stickyPost) {
					this.handleAutoExpire(this.state.autoExpireOptions[0])
					this.handleAutoDelete(this.state.autoExpireOptions[0])
				}
			},
		)
	}

	handleAllowComments = e => {
		this.setState({ allowComments: e.target.checked })
	}

	handleCoverStoryType = val => {
		this.setState({ selectedCoverStoryType: val })
	}

	handleAutoExpire = item => {
		this.setState({ selectedAutoExpireDate: item })
	}

	handleAutoDelete = item => {
		this.setState({ selectedAutoDeleteDate: item })
	}

	setStartDate = date => {
		this.setState({
			scheduledDate: date,
		})
		this.InAppMessageChild.current != undefined &&
			this.InAppMessageChild.current != null &&
			this.InAppMessageChild.current.handleChangeCampaignStartDateTime(date)
	}

	setPollClosingDate = date => {
		this.setState({
			pollClosingDate: date,
		})
	}

	handleCreateAs = val => {
		this.setState({ createAs: val })
	}

	handleSelectContributor = val => {
		this.setState({ selectedContributor: val })
	}

	handleSelectContentPlanner = val => {
		this.setState({ selectedContentPlanner: val })
	}

	handleSendNotification = e => {
		this.setState({ sendPushNotification: e.target.checked })
	}

	togglePNWithBigText = () => {
		this.setState({ sendPNWithBigText: !this.state.sendPNWithBigText })
	}

	handleSuggestionClick = async suggestion => {
		// let WPTagIds = this.state.WPTagIds
		const suggestionSelected = []
		const { tags } = this.state
		suggestionSelected.push(suggestion.hashTag)
		const tagIndex = tags.tagsArray.findIndex(
			item => item.toLowerCase() == suggestion.hashTag.toLowerCase(),
		)
		if (
			suggestion.wordPressTagID == null ||
			suggestion.wordPressTagID == undefined
		) {
			this.setState({
				newTagsArr: [...this.state.newTagsArr, suggestion.hashTag.substring(1)],
			})
		}

		if (tagIndex == -1) {
			tags.tagsArray.splice(0, 0, suggestion.hashTag)
		}

		const tagState = {
			tag: '',
			tagsArray: tags.tagsArray,
		}
		let tagWithType
		if (suggestion.SK.charAt(0) == 'g') {
			tagWithType = suggestion.hashTag + '@globalhashtag'
			if (suggestion.genderTarget) {
				const tagsWithGenderOption = this.state.tagsWithGenderArr
				tagsWithGenderOption.push(suggestion.hashTag)
				this.setState({ tagsWithGenderArr: tagsWithGenderOption })
				// this.props.updateTagsWithGenderArr(tagsWithGenderOption)
			}
		} else {
			tagWithType = suggestion.hashTag + '@userhashtag'
		}

		if (suggestion.isNewTag) {
			this.setState({
				newTagsArr: [...this.state.newTagsArr, suggestion.hashTag.substring(1)],
			})

			// this.props.updateNewTagsArr([...this.state.newTagsArr, suggestion.hashTag.substring(1)])
		}

		const hashTags = this.state.tagsArr
		const tagsWithType = this.state.tagsWithTypeArr
		const hashTagIndex = hashTags.findIndex(
			item => item.toLowerCase() == suggestion.hashTag.toLowerCase(),
		)
		if (hashTagIndex == -1) {
			hashTags.splice(0, 0, suggestion.hashTag)
		}

		const tagsIndex = tagsWithType.findIndex(
			item => item.toLowerCase() == tagWithType.toLowerCase(),
		)
		if (tagsIndex == -1) {
			tagsWithType.splice(0, 0, tagWithType)
		}

		// console.log(WPTagIds, 'WPTagIds')
		this.setState({
			// WPTagIds: WPTagIds,
			tagsWithTypeArr: tagsWithType,
			tagsArr: hashTags,
			tags: tagState,
			canEditTags: tagState.tagsArray.length != 4,
			suggestions: [],
			tagValue: '',
		})
	}

	removeTag = tagToDelete => {
		const wptags = this.state.WPTagIds
		const tagindex = this.state.tagsArr.indexOf(tagToDelete)
		wptags.splice(tagindex, 1)
		const filteredNewTags = this.state.newTagsArr.filter(tag => {
			if ('#' + tag.toLowerCase() != tagToDelete.toLowerCase()) {
				return tag
			}
		})

		const tagsWithType = this.state.tagsWithTypeArr
		const tags = this.state.tagsArr
		const index = this.state.tagsArr.indexOf(tagToDelete)
		tagsWithType.splice(index, 1)
		tags.splice(index, 1)
		const filteredGenderTags = this.state.tagsWithGenderArr.filter(
			tag => tag != tagToDelete,
		)

		this.setState({
			WPTagIds: wptags,
			newTagsArr: filteredNewTags,
			tagsWithTypeArr: tagsWithType,
			tagsArr: tags,
			tags: { tag: '', tagsArray: tags },
			selectedGenderType: filteredGenderTags.length
				? this.state.selectedGenderType
				: 'both',
			tagsWithGenderArr: filteredGenderTags,
			canEditTags: true,
		})
	}

	verifyLink = link => {
		const regex1 = new RegExp(
			'^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?',
		)
		return !regex1.test(link)
	}

	setItemSelected = (
		addTargetArea,
		addNewsToCategory,
		category,
		level,
		sublevel,
		level1Id,
		level2Id,
		level3Id,
	) => {
		const categoryData = category ? category : ''
		const levelData = level && level != 'All' ? '->' + level : ''
		const sublevelData = sublevel && sublevel != 'All' ? '->' + sublevel : ''
		const selectedCategory = categoryData + levelData + sublevelData

		const WPCatIds = []
		if (level1Id) {
			WPCatIds.push(level1Id)
		}

		if (level2Id) {
			WPCatIds.push(level2Id)
		}

		if (level3Id) {
			WPCatIds.push(level3Id)
		}

		this.setState({
			selectedCategory,
			addTargetAreasToWP: Boolean(addTargetArea),
			addNewsToCategory: Boolean(addNewsToCategory),
			WPCatIds,
		})
	}

	handlePnPriority = priority => {
		this.setState({ selectedPnPriority: priority })
	}

	handleSelectedPeopleList = peopleList => {
		this.setState({ selectedPeopleList: peopleList })
	}

	createTagValidations = text => {
		const tagSpaceValidation = text.includes(' ') && text.length <= 3
		const tagEnterValidation = text.includes('\n') && text.length <= 3
		const tagSpecialChar = text.match(/[^\w\s]/gi)
		const spaceEnterValidation = !tagSpaceValidation && !tagEnterValidation
		const createTag = spaceEnterValidation && !tagSpecialChar
		return createTag
	}

	handleOnChangeHashTag = async (text, tags, updateState) => {
		this.setState({ tagValue: text })
		const createTag = this.createTagValidations(text)
		if (createTag) {
			const tagsState = {
				tag: text,
				tagsArray: [],
			}
			// this.setState({ tags: tagsState })
			if (tagsState.tag.length >= 3) {
				let { tag } = tagsState
				tag = tag.replace(/ +(?= )/g, '')
				const newTagArr = []
				tag.split(' ').map((word, index) => {
					newTagArr.push(
						index != 0 ? word.charAt(0).toUpperCase() + word.substring(1) : word,
					)
				})
				const addTagToSuggestions = {
					hashTag: '#' + newTagArr.join(''),
					SK: 'userHashTag',
					isNewTag: true,
				}
				const tagInput = {
					hashTag: newTagArr.join(''),
					UUID: 'f198aa19-9b13-44cb-a0cc-f7e6edad89c8',
				}

				const suggestedHashTags = await GetListHashTagsofUserAndGlobal(
					tagInput,
				)
				const isTagAvailable =
					suggestedHashTags.items &&
					suggestedHashTags.items.filter(item => {
						if (
							item.hashTag.toLowerCase() ==
							'#' + newTagArr.join('').toLowerCase()
						) {
							return true
						}
					})
				if (isTagAvailable.length == 0) {
					suggestedHashTags.items.splice(0, 0, addTagToSuggestions)
				}

				this.setState({ suggestions: suggestedHashTags })
			} else {
				// this.setState({ suggestions: [] })
			}
			// return updateState(tempObject)
		}
	}

	handleMainCategory = category => {
		this.setState({ contentMainCategory: category })
	}

	contentButtonValidation = contentType => {
		const buttonSelected = contentType?.contentNewLinkDetails?.length > 0
		const buttonObjValidation =
			buttonSelected &&
			contentType?.contentNewLinkDetails?.some(item => {
				const buttonValidation = DynamicButtonValidations(item, true, false)
				return buttonValidation == true
			})
		if (buttonSelected) {
			return buttonObjValidation
		}

		return false
	}

	storyValidations = (story, allMandatoryValidations, slideShowPage) => {
		const { contentSelectedLangVal } = this.state
		const sTitle =
			story?.[`storyTitle_${contentSelectedLangVal}`] != undefined &&
			story?.[`storyTitle_${contentSelectedLangVal}`] != ''
		const sDescription =
			story?.[`storyCardDescription_${contentSelectedLangVal}`] != undefined &&
			story?.[`storyCardDescription_${contentSelectedLangVal}`] != ''
		// const wordpressImageValidation = this.state.syncToWordpress
		//   ? this.state.featuredImageId != ''
		//   : true
		const valuesArr = []
		if (story && story.storyCardImages && this.state.syncToWordpress) {
			story.storyCardImages.map((item, index) => {
				if (item.copyRight && item.copyRightText != '') {
					valuesArr.push(true)
				} else {
					valuesArr.push(false)
				}
			})
		}

		const isCopyRightTextAvailable = valuesArr.every(v => v === true)
		const isYoutube = story
			? Boolean(story.youtubeID && story.youtubeID != undefined)
			: false
		const youtubeOrientation = isYoutube
			? Boolean(story.youtubeVideoOrientation != undefined &&
				story.youtubeVideoOrientation != '')
			: true
		const sImages = !isYoutube
			? story?.storyCardImages != undefined &&
			story?.storyCardImages?.length > 0 &&
			isCopyRightTextAvailable
			: false
		const sVideo = story?.coverStoryVideoURL
		const sYoutube = story
			? story.youtubeID
				? story.youtubeID != '' && youtubeOrientation
				: false
			: true
		const sImageTemplate =
			story?.imageTemplate != undefined && story?.imageTemplate != ''
		const sVideoValidation = sVideo != undefined && sVideo != ''
		const youtubeImageValidation = this.state.syncToWordpress
			? story?.storyYoutubeImages != undefined &&
			story?.storyYoutubeImages?.length > 0
			: true
		const sYoutubeValidation =
			sYoutube != undefined &&
			sYoutube != '' &&
			isCopyRightTextAvailable &&
			((story?.storyCardImages != undefined &&
				story?.storyCardImages?.length > 0) ||
				youtubeImageValidation)
		const sImageTemplateValidation =
			sImages && sImageTemplate && sImageTemplate != ''
		const mediaValidation =
			sImages ||
			sVideoValidation ||
			sYoutubeValidation ||
			sImageTemplateValidation

		const buttonErrValidation = this.contentButtonValidation(story)
		if (allMandatoryValidations) {
			const withSlideShowKey = slideShowPage ? `Page${slideShowPage} ` : ''
			return {
				[`${withSlideShowKey}sTitle`]: sTitle,
				[`${withSlideShowKey}sDescription`]: sDescription,
				[`${withSlideShowKey}mediaValidation`]:
					mediaValidation == undefined ? false : mediaValidation,
				[`${withSlideShowKey}buttonErrValidation`]: !buttonErrValidation,
			}
		}

		return sTitle && sDescription && mediaValidation && !buttonErrValidation
	}

	liveNewsSectionValidations = (
		data,
		allMandatoryValidations,
		noOfSections,
		sectionIndex,
	) => {
		const { contentSelectedLangVal } = this.state
		let sTitle; let sDescription; let mediaValidation; let buttonErrValidation

		sTitle =
			data?.[`liveNewsTitle_${contentSelectedLangVal}`] != undefined &&
			data?.[`liveNewsTitle_${contentSelectedLangVal}`] != ''
		sDescription =
			data?.[`liveNewsDescription_${contentSelectedLangVal}`] != undefined &&
			data?.[`liveNewsDescription_${contentSelectedLangVal}`] != ''
		const valuesArr = []
		if (data && data.liveNewsImages) {
			data.liveNewsImages.map((data, index) => {
				if (data.copyRight && data.copyRightText != '') {
					valuesArr.push(true)
				} else {
					valuesArr.push(false)
				}
			})
		}

		const isCopyRightTextAvailable = valuesArr.every(v => v === true)

		const isYoutube = data
			? Boolean(data.liveNewsYoutubeID && data.liveNewsYoutubeID != undefined)
			: false
		const youtubeOrientation = isYoutube
			? Boolean(data.youtubeVideoOrientation != undefined &&
				data.youtubeVideoOrientation != '')
			: true
		const sImages = !isYoutube
			? data?.liveNewsImages != undefined &&
			data?.liveNewsImages?.length > 0 &&
			isCopyRightTextAvailable
			: false
		const sVideo = data?.liveNewsVideoURL
		const sYoutube = data
			? data.liveNewsYoutubeID
				? data.liveNewsYoutubeID != '' && youtubeOrientation
				: false
			: true
		const sVideoValidation = sVideo != undefined && sVideo != ''
		// const youtubeImageValidation = this.state.syncToWordpress
		//   ? data?.liveNewsYoutubeImages != undefined &&
		//     data?.liveNewsYoutubeImages?.length > 0
		//   : true;
		const sYoutubeValidation = sYoutube != undefined && sYoutube != ''

		mediaValidation = sImages || sVideoValidation || sYoutubeValidation
		buttonErrValidation = this.contentButtonValidation(data)
		const sectionValidation = noOfSections
			? sTitle || sDescription || mediaValidation
			: false

		if (allMandatoryValidations) {
			const sectionValue = sectionIndex ? `Section${sectionIndex} ` : ''

			if (sectionValidation) {
				return {
					[`${sectionValue}buttonErrValidation`]: !buttonErrValidation,
				}
			}

			return {
				[`${sectionValue}Title`]: sTitle,
				[`${sectionValue}Description`]: sDescription,
				[`${sectionValue}mediaValidation`]:
					mediaValidation == undefined ? false : mediaValidation,
				[`${sectionValue}buttonErrValidation`]: !buttonErrValidation,
			}
		}

		return sectionValidation
			? (sTitle || sDescription || mediaValidation) && !buttonErrValidation
			: sTitle && sDescription && mediaValidation && !buttonErrValidation
	}

	liveNewsValidations = (data, allMandatoryValidations) => {
		const validation = []
		let liveNewsSectionMissingFields = {}
		if (data && data.length > 0) {
			data?.map((item, index) => {
				if (allMandatoryValidations) {
					const missingliveNewsSectionFields = this.liveNewsSectionValidations(
						item,
						allMandatoryValidations,
						data.length > 1,
						index + 1,
					)
					liveNewsSectionMissingFields = {
						...liveNewsSectionMissingFields,
						...missingliveNewsSectionFields,
					}
				}

				validation.push(
					this.liveNewsSectionValidations(
						item,
						allMandatoryValidations,
						data.length > 1,
					),
				)
			})
		}

		const checker = validation.every(v => v === true)

		if (allMandatoryValidations) {
			return liveNewsSectionMissingFields
		}

		return checker
	}

	liveCricketScoreValidations = (liveCricket, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		const featuredMatchValidation =
			liveCricket?.matchKey != undefined && liveCricket?.matchKey != ''
		const buttonErrValidation = this.contentButtonValidation(liveCricket)
		if (allMandatoryValidations) {
			return {
				featuredMatchValidation,
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return featuredMatchValidation && !buttonErrValidation
	}

	cricketPointsTableValidations = (
		cricketPointsTable,
		allMandatoryValidations,
	) => {
		const { contentSelectedLangVal } = this.state
		const cricketPointsTableTitle =
			cricketPointsTable?.[
			`cricketPointsTableTitle_${contentSelectedLangVal}`
			] != undefined &&
			cricketPointsTable?.[
			`cricketPointsTableTitle_${contentSelectedLangVal}`
			] != ''
		const cricketPointsTableImages =
			cricketPointsTable?.cricketPointsTableImages != undefined &&
			cricketPointsTable?.cricketPointsTableImages?.length > 0
		const tournamentValidation =
			cricketPointsTable?.tournamentKey != undefined &&
			cricketPointsTable?.tournamentKey != ''
		const associationValidation =
			cricketPointsTable?.associationKey != undefined &&
			cricketPointsTable?.associationKey != ''

		const buttonErrValidation = this.contentButtonValidation(
			cricketPointsTable,
		)
		if (allMandatoryValidations) {
			return {
				cricketPointsTableTitle,
				// [`cricketPointsTableDescription`]: cricketPointsTableDescription,
				tournamentValidation,
				associationValidation,
				cricketPointsTableImages:
					cricketPointsTableImages == undefined
						? false
						: cricketPointsTableImages,
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return (
			cricketPointsTableTitle &&
			// cricketPointsTableDescription &&
			cricketPointsTableImages &&
			tournamentValidation &&
			associationValidation &&
			!buttonErrValidation
		)
	}

	slideShowValidations = (slideShow, allMandatoryValidations) => {
		const validation = []
		let slideshowMissingFields = {}
		slideShow.pages &&
			slideShow.pages.map((page, index) => {
				if (page.pageType == 'Story') {
					if (allMandatoryValidations) {
						const missingStoryFields = this.storyValidations(
							page.storyDetails,
							allMandatoryValidations,
							index + 1,
						)
						slideshowMissingFields = {
							...slideshowMissingFields,
							...missingStoryFields,
						}
					}

					validation.push(
						this.storyValidations(page.storyDetails, allMandatoryValidations),
					)
				} else if (page.pageType == 'CoverStory') {
					const fromSlideshow = true
					if (allMandatoryValidations) {
						const missingStoryFields = this.onlyCoverValidataion(
							page.coverStoryDetails?.onlyCoverDetails,
							fromSlideshow,
							allMandatoryValidations,
							index + 1,
						)
						slideshowMissingFields = {
							...slideshowMissingFields,
							...missingStoryFields,
						}
					}

					validation.push(
						this.onlyCoverValidataion(
							page.coverStoryDetails.onlyCoverDetails,
							fromSlideshow,
							allMandatoryValidations,
						),
					)
				}
			})
		const checker = validation.every(v => v === true)
		if (allMandatoryValidations) {
			return slideshowMissingFields
		}

		return checker
	}

	mcqValidations = (mcq, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		const mcqTitle =
			mcq?.[`mcqTitle_${contentSelectedLangVal}`] != undefined &&
			mcq?.[`mcqTitle_${contentSelectedLangVal}`] != ''
		const mcqImages = mcq.mcqImages != undefined && mcq.mcqImages.length > 0
		const mcqCardImages =
			mcq.mcqCardImages != undefined && mcq.mcqCardImages.length > 0
		const ansExplanation =
			mcq?.[`answerExplanation_${contentSelectedLangVal}`] != undefined &&
			mcq?.[`answerExplanation_${contentSelectedLangVal}`] != ''
		// const textValidations = mcqTitle && ansExplanation && this.checkAnswersInfoValidations()
		const textValidations =
			mcqTitle && ansExplanation && this.checkAnswersInfoValidations()
		const imageValidations = mcqImages && mcqCardImages
		const buttonErrValidation = this.contentButtonValidation(mcq)

		if (allMandatoryValidations) {
			return {
				mcqTitle,
				ansExplanation,
				mcqImages,
				mcqCardImages,
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return textValidations && imageValidations & !buttonErrValidation
	}

	pollValidations = (poll, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		const pollTitle =
			poll?.[`pollTitle_${contentSelectedLangVal}`] != undefined &&
			poll?.[`pollTitle_${contentSelectedLangVal}`] != ''
		const pollImage = poll.pollImage != undefined && poll.pollImage?.length > 0
		const pollInfo = poll.pollInfo != undefined && poll.pollInfo?.length > 0
		const textValidations =
			pollTitle && pollInfo && this.checkpollInfoValidations()
		const imageValidations = pollImage
		const buttonErrValidation = this.contentButtonValidation(poll)
		if (allMandatoryValidations) {
			return {
				pollTitle,
				pollImage,
				pollInfoValidations: pollInfo && this.checkpollInfoValidations(),
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return textValidations && imageValidations && !buttonErrValidation
	}

	flipToStoryValidataion = (flipToStory, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		const fsTitle =
			flipToStory?.[`coverStoryTitle_${contentSelectedLangVal}`] != undefined &&
			flipToStory?.[`coverStoryTitle_${contentSelectedLangVal}`] != ''
		const fsCardDesc =
			flipToStory?.[`coverStoryCardDescription_${contentSelectedLangVal}`] !=
			undefined &&
			flipToStory?.[`coverStoryCardDescription_${contentSelectedLangVal}`] !=
			''
		const fsVideo =
			flipToStory.coverStoryVideoURL && flipToStory.coverStoryVideoURL != ''
		const fsYoutube = flipToStory.youtubeID && flipToStory.youtubeID != ''
		const fsImages =
			flipToStory.coverStoryImages != undefined &&
			flipToStory.coverStoryImages.length > 0
		const fsCardImages =
			flipToStory.coverStoryCardImages != undefined &&
			flipToStory.coverStoryCardImages.length > 0
		const textValidations = fsTitle && fsCardDesc
		const imageValidations = fsImages && fsCardImages
		const fsYoutubeValidations = fsYoutube != undefined && fsYoutube != ''
		const fsVideoValidation = fsVideo != undefined && fsVideo != ''
		const mediaValidation =
			imageValidations || fsYoutubeValidations || fsVideoValidation
		const buttonErrValidation = this.contentButtonValidation(flipToStory)
		if (allMandatoryValidations) {
			return {
				fsTitle,
				fsCardDesc,
				mediaValidation: mediaValidation == undefined ? true : mediaValidation,
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return textValidations && mediaValidation && !buttonErrValidation
	}

	onlyCoverValidataion = (
		onlyCover,
		fromSlideshow,
		allMandatoryValidations,
		slideShowPage,
	) => {
		const { contentSelectedLangVal } = this.state
		const csTitle =
			onlyCover != undefined && fromSlideshow
				? true
				: onlyCover[`coverStoryTitle_${contentSelectedLangVal}`]
		const csCardDesc =
			onlyCover != undefined && fromSlideshow
				? true
				: onlyCover[`coverStoryCardDescription_${contentSelectedLangVal}`]
		const csVideo =
			onlyCover.coverStoryVideoURL && onlyCover.coverStoryVideoURL != ''
		const csYoutube = onlyCover.youtubeID && onlyCover.youtubeID != ''
		const csImages =
			onlyCover.coverStoryImages != undefined &&
			onlyCover.coverStoryImages.length > 0
		const csVideoValidation = csVideo != undefined && csVideo != ''
		const csYoutubeValidation = csYoutube != undefined && csYoutube != ''
		const csEmbedUrl = onlyCover.embedURL && onlyCover.embedURL != ''
		const csEmbedUrlValidation = csEmbedUrl != undefined && csEmbedUrl != ''
		const mediaValidation =
			csVideoValidation ||
			csYoutubeValidation ||
			csImages ||
			csEmbedUrlValidation
		const textValidations = csTitle && csCardDesc
		const buttonErrValidation = this.contentButtonValidation(onlyCover)
		const withSlideShowKey = slideShowPage ? `Page${slideShowPage} ` : ''

		if (allMandatoryValidations) {
			return {
				[`${withSlideShowKey}csTitle`]: csTitle,
				[`${withSlideShowKey}csCardDesc`]: csCardDesc,
				[`${withSlideShowKey}mediaValidation`]: mediaValidation,
				[`${withSlideShowKey}buttonErrValidation`]: !buttonErrValidation,
			}
		}

		return textValidations && mediaValidation && !buttonErrValidation
	}

	inAppBrowserValidataion = (inAppBrowser, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		const inAppTitle =
			inAppBrowser?.[`coverStoryTitle_${contentSelectedLangVal}`] !=
			undefined &&
			inAppBrowser?.[`coverStoryTitle_${contentSelectedLangVal}`] != ''
		const inAppImages =
			inAppBrowser.coverStoryImages != undefined &&
			inAppBrowser.coverStoryImages.length > 0
		const inAppLink = inAppBrowser.link != undefined && inAppBrowser.link != ''
		const inAppLinkText =
			inAppBrowser.linkText != undefined && inAppBrowser.linkText != ''
		const textValidations = inAppTitle && inAppLink && inAppLinkText
		const imageValidations = inAppImages && this.verifyLink(inAppLink)
		const buttonErrValidation = this.contentButtonValidation(inAppBrowser)

		if (allMandatoryValidations) {
			return {
				inAppTitle,
				inAppImages,
				inAppLink,
				inAppLinkText,
				buttonErrValidation: !buttonErrValidation,
			}
		}

		return textValidations && imageValidations && !buttonErrValidation
	}

	checkSubContentValidations = () => {
		const { selectedContentType } = this.state
		if (selectedContentType == 'Story' || selectedContentType == 'ShortByte') {
			return this.storyValidations(this.story)
		}

		if (selectedContentType == 'CoverStory') {
			const {
				flipToStoryDetails,
				onlyCoverDetails,
				inAppBrowserDetails,
			} = this.coverStory
			return this.coverStorySubType == 'FlipToStory'
				? this.flipToStoryValidataion(flipToStoryDetails)
				: this.coverStorySubType == 'OnlyCover'
					? this.onlyCoverValidataion(onlyCoverDetails, false)
					: this.coverStorySubType == 'InAppBrowser'
						? this.inAppBrowserValidataion(inAppBrowserDetails)
						: false
		}

		if (selectedContentType == 'Mcq') {
			return this.mcqValidations(this.mcq)
		}

		if (selectedContentType == 'SlideShow') {
			return this.slideShowValidations(this.slideShow)
		}

		if (selectedContentType == 'Poll') {
			return this.pollValidations(this.poll)
		}

		if (selectedContentType == 'liveCricketScore') {
			return this.liveCricketScoreValidations(this.liveCricket)
		}

		if (selectedContentType == 'cricketPointsTable') {
			return this.cricketPointsTableValidations(this.cricketPointsTable)
		}

		if (selectedContentType == 'liveNews') {
			return this.liveNewsValidations(this.liveNews)
		}

		return false
	}

	checkCreateContentValidations = () => this.checkSubContentValidations()

	handleFeaturedMatchKey = key => {
		this.setState({ matchKey: key })
	}

	handleTeamsShortCodes = shortCodes => {
		this.setState({ teamsShortCodes: shortCodes })
	}

	handleSelectedTournament = key => {
		this.setState({ tournamentKey: key })
	}

	handleSelectedAssociation = key => {
		this.setState({ associationKey: key })
	}

	CoverStoryData = (key, value, type, subType) => {
		if (subType == 'FlipToStory') {
			this.coverStory.flipToStoryDetails[key] = value
		} else if (subType == 'OnlyCover') {
			this.coverStory.onlyCoverDetails[key] = value
		} else if (subType == 'InAppBrowser') {
			this.coverStory.inAppBrowserDetails[key] = value
		}

		if (this.coverStorySubType != subType) {
			this.coverStorySubType = subType
		}

		if (key.includes('coverStoryTitle')) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (!this.state.editContent && key.includes('coverStoryCardDescription')) {
			this.setState({ pnDescription: value, bigTextTitle: value })
		}

		if (
			key == 'coverStoryImages' &&
			subType == 'FlipToStory' &&
			value &&
			value[0]
		) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}

		if (
			(key == 'coverStoryVideoURL' || key == 'youtubeID') &&
			subType !== 'FlipToStory'
		) {
			this.contentImage = ''
			this.contentImages = ''
		}
	}

	cricketPointsTableData = (key, value) => {
		if (key.includes('cricketPointsTableImages') && value && value[0]) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}

		if (key.includes('cricketPointsTableTitle')) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (key.includes('cricketPointsTableDescription')) {
			this.setState({ pnDescription: value })
		}

		this.cricketPointsTable[key] = value
	}

	liveCricketData = (key, value) => {
		if (key.includes('matchTitle')) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		this.liveCricket[key] = value
	}

	storyData = (key, value) => {
		this.story[key] = value
		if (key.includes('storyTitle')) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (
			this.props.duplicateContent ||
			(!this.state.editContent && key.includes('storyCardDescription'))
		) {
			this.setState({ pnDescription: value, bigTextTitle: value })
		}

		if (key.includes('storyCardImages') && value && value[0]) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}

		if (key == 'coverStoryVideoURL' || key == 'youtubeID') {
			this.contentImage = ''
			this.contentImages = ''
		}
	}

	liveNewsData = data => {
		if (data && data.length > 0) {
			data.map((item, index) => {
				if (Object.keys(item).length > 0) {
					const images = Object.keys(item).includes('liveNewsImages')
					const videoURL = Object.keys(item).includes('liveNewsVideoURL')
					const youtubeID = Object.keys(item).includes('liveNewsYoutubeID')

					if (images && item[images] && item[images][0]) {
						this.contentImage = item[images][0].image
						this.contentImages = item[images][0].image
					}

					if (videoURL || youtubeID) {
						this.contentImage = ''
						this.contentImages = ''
					}
				}
			})
			const title = data[0].liveNewsTitle_Te
				? data[0].liveNewsTitle_Te
				: data[0].liveNewsTitle_En
			const desc = data[0].liveNewsDescription_Te
				? data[0].liveNewsDescription_Te
				: data[0].liveNewsDescription_En

			if (title) {
				this.setState({ pnTitle: title.substring(0, 45) })
			}

			if (!this.state.editContent && desc) {
				this.setState({
					pnDescription: desc,
					bigTextTitle: desc,
				})
			}
		}
	}

	McqData = (key, value) => {
		this.mcq[key] = value
		if (key.includes('mcqTitle')) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (key.includes('mcqImages') && value && value[0]) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}
	}

	slideShowData = (key, value) => {
		if (key.includes('slideShowTitle') && value) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (
			!this.state.editContent &&
			key.includes('slideShowDescription') &&
			value
		) {
			this.setState({ pnDescription: value, bigTextTitle: value })
		}

		if (key.includes('slideShowImage') && value) {
			this.contentImage = value
			this.contentImages = value
		}

		if (key.includes('slideShowImage') && !value) {
			this.contentImage = ''
			this.contentImages = ''
		}

		if (value != '' && value != null && value != undefined) {
			this.slideShow[key] = value
		}

		delete this.slideShow.slideShowDescription
	}

	pollData = (key, value) => {
		this.poll[key] = value
		if (key.includes('pollTitle') && value) {
			this.setState({ pnTitle: value.substring(0, 45) })
		}

		if (!this.state.editContent && key.includes('pollDescription') && value) {
			this.setState({ pnDescription: value, bigTextTitle: value })
		}

		if (key.includes('pollImage') && value && value[0]) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}
	}

	setFeaturedImageId = featuredImageId => {
		// set featured image id received from wordpress upload media
		this.setState({ featuredImageId }, () => {
			const createContentValidation = this.checkCreateContentValidations()
			this.setState({ enableCreateContent: createContentValidation })
		})
	}

	updateWordpressPermalink = permalink => {
		this.setState({ permalink })
	}

	syncToWordpress = syncToWordpress => {
		this.setState({ syncToWordpress }, () => {
			const createContentValidation = this.checkCreateContentValidations()
			this.setState({ enableCreateContent: createContentValidation })
		})
	}

	disableSyncToWordPress = disableSyncToWordPress => {
		this.setState({ disableSyncToWordPress })
	}

	updateInParent = (key, value, type, subType) => {
		const { enableCreateContent } = this.state
		if (type == 'Story' || type == 'ShortByte') {
			this.storyData(key, value, type, subType)
		} else if (type == 'liveCricketScore') {
			this.liveCricketData(key, value)
		} else if (type == 'cricketPointsTable') {
			this.cricketPointsTableData(key, value)
		} else if (type == 'CoverStory') {
			this.CoverStoryData(key, value, type, subType)
		} else if (type == 'Mcq') {
			this.McqData(key, value)
		} else if (type == 'SlideShow') {
			this.slideShowData(key, value)
		} else if (type == 'Poll') {
			this.pollData(key, value)
		} else if (type == 'liveNews') {
			this.liveNews = value
			this.liveNewsData(this.liveNews)
		}

		const createContentValidation = this.checkCreateContentValidations()
		if (enableCreateContent != createContentValidation) {
			this.setState({
				enableCreateContent: createContentValidation,
				updateErrorValidations: !this.state.updateErrorValidations,
			})
		} else {
			this.setState({
				updateErrorValidations: !this.state.updateErrorValidations,
			})
		}
	}

	updateVideodetails = videoDetails => {
		this.videoDetails = videoDetails
	}

	appendhashToTag = tag => {
		if (tag.substring(0, 1) != '#') {
			return '#' + tag
		}

		return tag
	}

	getScheduledDate = () => {
		const { scheduledDate } = this.state
		const date = scheduledDate.getDate()
		const month = scheduledDate.getMonth() + 1
		const year = scheduledDate.getFullYear()
		const formatteddate = date + '/' + month + '/' + year
		return formatteddate
	}

	getScheduledTime = () => {
		const { scheduledDate } = this.state
		const time = Math.trunc(scheduledDate.getTime() / 1000)
		return time
	}

	handleModal = () => {
		this.setState({ modalVisible: !this.state.modalVisible })
	}

	getSlideShowData = preview => {
		let slideShowPages = this.slideShow.pages
		const { contentSelectedLangVal } = this.state
		slideShowPages = GetSlideShowPagesData(preview, slideShowPages)
		this.slideShow.slideShowImage = this.slideShow.slideShowImage?.substring(
			this.slideShow.slideShowImage.indexOf('public'),
		)
		this.slideShow.slideShowTitle = this.slideShow.slideShowTitle
		this.slideShow[
			`slideShowTitle_${contentSelectedLangVal}`
		] = this.slideShow.slideShowTitle
		this.slideShow.pages = slideShowPages
		return this.slideShow
	}

	previewInputData = async contentType => {
		const { createAs, selectedContributor } = this.state
		const userInput = { handle: '@YouSayEditor' }
		const loggedInUserEmail = Auth.user.attributes
			? Auth.user.attributes.email
			: ''
		let loggedInUserDetails = {}
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split('@')
			const loggedInUserHandle = '@' + emailParams[0]
			const handleInput = { YouSayID: loggedInUserHandle }
			loggedInUserDetails = await GetYouSayIdDetails(handleInput)
		}

		const data = await GetYousayInAppUser(userInput)

		const createdAs =
			createAs == 'other'
				? selectedContributor.name
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.name
						? loggedInUserDetails && loggedInUserDetails.name
						: data.name
					: data.name
		const creatorID =
			createAs == 'other'
				? selectedContributor.PK
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.PK
						? loggedInUserDetails && loggedInUserDetails.PK
						: data.UUID
					: data.UUID
		this.coverStory.coverStoryType = this.coverStorySubType
		const input = {
			createdFrom: 'Web',
			contentID: this.state.contentID,
			createdAs,
			contentType: this.state.selectedContentType,
			contentMainCategory: this.state.contentMainCategory,
			creatorUUID: creatorID,
			type: 'content',
			contentLanguage: this.state.contentLang,
			allowShare: this.state.allowShare,
			createInBoxOffice: this.state.createInBoxOffice,
			allowComments: this.state.allowComments,
			genderSpecific: this.state.selectedGenderType,
			tagsWithGenderTarget: this.state.tagsWithGenderArr,
			contentMetaInfo: {
				contentImage: this.contentImage,
				storyDetails:
					contentType == 'Story' || contentType == 'ShortByte'
						? this.story
						: {},
				coverStoryDetails: contentType == 'CoverStory' ? this.coverStory : {},
				mcqDetails: contentType == 'Mcq' ? this.mcq : {},
				pollDetails: contentType == 'Poll' ? this.poll : {},
				slideShowDetails:
					contentType == 'SlideShow' ? await this.getSlideShowData(true) : {},
			},
			scheduledDate: this.getScheduledDate(),
			scheduledTime: this.getScheduledTime(),
			contentStatus: 'draft',
			contentVersion: 2,
			sendPushNotification: this.state.sendPushNotification,
		}
		input.pnTitle = this.state.pnTitle.substring(0, 45)
		if (this.state.sendPushNotification) {
			input.sendPNWithImage = this.state.sendPNWithImage

			if (this.state.sendPNWithImage) {
				input.pnDescription = this.state.pnDescription
			} else {
				input.bigTextTitle = this.state.bigTextTitle
			}
		}

		this.state.tagsArr.map((item, index) => {
			input['creatorVideoHashTag' + (index + 1)] = this.appendhashToTag(item)
		})
		this.state.tagsWithTypeArr.map((item, index) => {
			input[
				'creatorVideoHashTag' + (index + 1) + 'AndType'
			] = this.appendhashToTag(item)
		})
		if (this.state.selectedCategory != '') {
			const contentCategories = this.state.selectedCategory.split('->')
			contentCategories.map((item, index) => {
				input['contentCategory' + (index + 1)] = item.trim()
			})
		}

		if (input.contentMetaInfo) {
			const clearImageCacheInput = {
				imagePath: input.contentMetaInfo.contentImage
					? input.contentMetaInfo.contentImage
					: '',
			}
			console.log(
				clearImageCacheInput,
				'=================clearImageCacheInput',
			)
			if (
				clearImageCacheInput != undefined &&
				clearImageCacheInput != null &&
				clearImageCacheInput.imagePath != null &&
				clearImageCacheInput.imagePath != undefined &&
				clearImageCacheInput.imagePath != ''
			) {
				const response = await ClearImageCloudFrontCache(clearImageCacheInput)
				console.log(response, 'response ClearImageCloudFrontCache==========')
			}
		}

		return input
	}

	getStoryData = () => {
		if (this.story && this.story.youtubeID && this.story.youtubeID != '') {
			if (this.story.storyCardImages && this.story.storyCardImages.length > 0) {
				this.story.storyYoutubeImages = this.story.storyCardImages
				delete this.story.storyCardImages
			}
		}

		if (
			this.story &&
			this.story.storyCardImages &&
			this.state.syncToWordpress
		) {
			this.story.storyCardImages.map((item, index) => {
				if (item.copyRightText == 'Movies') {
					item.copyRight = false
					item.copyRightText = 'Movies'
				}

				item.position && delete item.position
			})
		}

		delete this.story.storyCardOriginalImages
		return this.story
	}

	getLiveNewsData = (liveNewsData, createdAs, createdFrom, editcontent) => {
		liveNewsData.map((sectionItem, sectionIndex) => {
			if (
				sectionItem.liveNewsYoutubeID &&
				sectionItem.liveNewsYoutubeID != ''
			) {
				if (
					sectionItem.liveNewsImages &&
					sectionItem.liveNewsImages.length > 0
				) {
					sectionItem.liveNewsYoutubeImages = sectionItem.liveNewsImages
					delete sectionItem.liveNewsImages
				}
			}

			if (
				sectionItem &&
				sectionItem.liveNewsImages &&
				this.state.syncToWordpress
			) {
				sectionItem.liveNewsImages.map((imageItem, imageIndex) => {
					if (imageItem.copyRightText == 'Movies') {
						imageItem.copyRight = false
						imageItem.copyRightText = 'Movies'
					}
				})
			}

			sectionItem.createdFrom = createdFrom
			if (editcontent && sectionItem.isNewSection) {
				sectionItem.createdDateTime = Math.trunc(new Date().getTime() / 1000)
				sectionItem.createdAs = createdAs
			} else if (editcontent && !sectionItem.isNewSection) {
				sectionItem.createdDateTime = sectionItem.createdDateTime
				sectionItem.createdAs = sectionItem.createdAs
				sectionItem.modifiedBy = sectionItem.isEdited
					? createdAs
					: sectionItem.modifiedBy
				sectionItem.modifiedDateTime = sectionItem.isEdited
					? Math.trunc(new Date().getTime() / 1000)
					: sectionItem.modifiedDateTime
			} else {
				sectionItem.createdDateTime = Math.trunc(new Date().getTime() / 1000)
				sectionItem.createdAs = createdAs
			}

			delete sectionItem.isNewSection
			delete sectionItem.isEdited
		})
		return this.liveNews
	}

	getLiveCricketInfo = () => {
		delete this.liveCricket.matchKey
		delete this.liveCricket.matchTitle
		return this.liveCricket
	}

	getPointsTableInfo = () => {
		delete this.cricketPointsTable.tournamentKey
		delete this.cricketPointsTable.associationKey
		return this.cricketPointsTable
	}

	getPollData = () => {
		delete this.poll.pollOriginalImages
		return this.poll
	}

	getCoverStoryData = () => {
		if (this.coverStory.coverStoryType == 'FlipToStory') {
			delete this.coverStory.flipToStoryDetails.coverStoryCardOriginalImages
			delete this.coverStory.flipToStoryDetails.coverStoryOriginalImages
		} else if (this.coverStory.coverStoryType == 'OnlyCover') {
			delete this.coverStory.onlyCoverDetails.coverStoryOriginalImages
		} else {
			delete this.coverStory.inAppBrowserDetails.coverStoryOriginalImages
		}

		return this.coverStory
	}

	getMcqData = () => {
		delete this.mcq.mcqOriginalCardImages
		delete this.mcq.mcqOriginalImages
		return this.mcq
	}

	getFormattedStoryImages = () => {
		let imagesArr = []
		if (this.story.storyCardImages) {
			imagesArr = getFormattedImages(this.story.storyCardImages)
		}

		return imagesArr
	}

	getFormattedStoryYoutubeImages = () => {
		let imagesArr = []
		if (this.story.storyYoutubeImages) {
			imagesArr = getFormattedImages(this.story.storyYoutubeImages)
		}

		return imagesArr
	}

	getFormattedFlipToStoryCardImages = () => {
		const imagesArr = getFormattedImages(
			this.coverStory.flipToStoryDetails.coverStoryCardImages,
		)
		return imagesArr
	}

	getFormattedFlipToStoryImages = () => {
		const imagesArr = getFormattedImages(
			this.coverStory.flipToStoryDetails.coverStoryImages,
		)
		return imagesArr
	}

	getFormattedOnlyCoverImages = () => {
		const imagesArr = getFormattedImages(
			this.coverStory.onlyCoverDetails.coverStoryImages,
		)
		return imagesArr
	}

	getFormattedPollImages = () => {
		const imagesArr = []
		this.poll?.pollImage?.filter(item => {
			const imagePath = item.image.substring(item.image.indexOf('public'))
			const obj = {
				image: imagePath,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		return imagesArr
	}

	getFormattedMcqImages = () => {
		const imagesArr = getFormattedImages(this.mcq.mcqImages)
		return imagesArr
	}

	getFormattedMcqCardImages = () => {
		const imagesArr = getFormattedImages(this.mcq.mcqCardImages)
		return imagesArr
	}

	getFormattedInAppBrowserImages = () => {
		const imagesArr = getFormattedImages(
			this.coverStory.inAppBrowserDetails.coverStoryImages,
		)
		return imagesArr
	}

	removeCdnUrl = (page, pageType, url) => {
		const cdnurl = AwsConfig.cdn_url
		if (url?.includes(cdnurl)) {
			page[pageType].coverStoryVideoURL = page[
				pageType
			].coverStoryVideoURL.substring(
				page[pageType].coverStoryVideoURL.indexOf('public'),
			)
		}
	}

	DeleteTypeAndFormatImages = async contentType => {
		if (contentType == 'Story' || contentType == 'ShortByte') {
			this.story.storyCardImages = await this.getFormattedStoryImages()
			this.story.storyYoutubeImages = await this.getFormattedStoryYoutubeImages()
			if (this.story.coverStoryVideoURL) {
				const videoUrlSubString = this.story.coverStoryVideoURL.substring(
					this.story.coverStoryVideoURL.indexOf('public'),
				)
				this.story.coverStoryVideoURL = videoUrlSubString
			}
		} else if (contentType == 'CoverStory') {
			if (this.coverStory.coverStoryType == 'FlipToStory') {
				if (this.coverStory.flipToStoryDetails.coverStoryVideoURL) {
					const videoUrlSubString = this.coverStory.flipToStoryDetails.coverStoryVideoURL.substring(
						this.coverStory.flipToStoryDetails.coverStoryVideoURL.indexOf(
							'public',
						),
					)
					this.coverStory.flipToStoryDetails.coverStoryVideoURL = videoUrlSubString
				}

				this.coverStory.flipToStoryDetails.coverStoryCardImages = await this.getFormattedFlipToStoryCardImages()
				this.coverStory.flipToStoryDetails.coverStoryImages = await this.getFormattedFlipToStoryImages()
			} else if (this.coverStory.coverStoryType == 'OnlyCover') {
				if (this.coverStory.onlyCoverDetails.coverStoryVideoURL) {
					const videoUrlSubString = this.coverStory.onlyCoverDetails.coverStoryVideoURL.substring(
						this.coverStory.onlyCoverDetails.coverStoryVideoURL.indexOf(
							'public',
						),
					)
					this.coverStory.onlyCoverDetails.coverStoryVideoURL = videoUrlSubString
				}

				this.coverStory.onlyCoverDetails.coverStoryImages = await this.getFormattedOnlyCoverImages()
			} else if (this.coverStory.coverStoryType == 'InAppBrowser') {
				this.coverStory.inAppBrowserDetails.coverStoryImages = await this.getFormattedInAppBrowserImages()
			}
		} else if (contentType == 'Mcq') {
			this.mcq.mcqImages = await this.getFormattedMcqImages()
			this.mcq.mcqCardImages = await this.getFormattedMcqCardImages()
		} else if (contentType == 'Poll') {
			this.poll.pollImage = await this.getFormattedPollImages()
		} else if (contentType == 'SlideShow') {
			this.slideShow?.pages?.map(page => {
				if (
					(page.pageType == 'Story' || page.pageType == 'ShortByte') &&
					page?.storyDetails?.coverStoryVideoURL
				) {
					this.removeCdnUrl(
						page,
						'storyDetails',
						page?.storyDetails?.coverStoryVideoURL,
					)
				} else if (
					page.pageType == 'CoverStory' &&
					page?.coverStoryDetails?.onlyCoverDetails?.coverStoryVideoURL
				) {
					this.removeCdnUrl(
						page.coverStoryDetails,
						'onlyCoverDetails',
						page?.coverStoryDetails?.onlyCoverDetails?.coverStoryVideoURL,
					)
				}
			})
		}
	}

	getCoverStoryType = () => {
		const coverStoryType = GetCoverStoryType(
			this.props.editContent,
			this.props.contentDetails,
		)
		this.coverStory.coverStoryType = this.props.editContent
			? coverStoryType
			: this.coverStorySubType
	}

	contentInputData = async contentType => {
		const { contentDetails } = this.props
		const {
			createAs,
			selectedContributor,
			contentSelectedLangVal,
		} = this.state

		const { editContent } = this.props
		const userInput = { handle: '@YouSayEditor' }
		const loggedInUserEmail = Auth.user.attributes
			? Auth.user.attributes.email
			: ''
		let loggedInUserDetails = {}
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split('@')
			const loggedInUserHandle = '@' + emailParams[0]
			const handleInput = { YouSayID: loggedInUserHandle }
			loggedInUserDetails = await GetYouSayIdDetails(handleInput)
		}

		const data = await GetYousayInAppUser(userInput)

		const createdAs =
			createAs == 'other'
				? selectedContributor.name
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.name
						? loggedInUserDetails.name
						: data.name
					: data.name
		const creatorID =
			createAs == 'other'
				? selectedContributor.PK
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.PK
						? loggedInUserDetails.PK
						: data.UUID
					: data.UUID
		this.coverStory.coverStoryType = this.coverStorySubType
		if (this.props.editContent) {
			await this.DeleteTypeAndFormatImages(contentType)
		}

		const contentLangs =
			editContent && contentDetails.contentLanguages
				? contentDetails.contentLanguages
				: []
		contentLangs.push(contentSelectedLangVal)
		const updatedContentLanguages = _.uniqBy(contentLangs)
		await this.getCoverStoryType()
		const type =
			this.state.selectedContentType == 'liveCricketScore' ||
				this.state.selectedContentType == 'cricketPointsTable' ||
				this.state.selectedContentType == 'ShortByte'
				? 'Story'
				: this.state.selectedContentType
		const targetAreaV2 = []
		this.state.selectedTargetAreas.map((item, index) => {
			targetAreaV2.push(item.heading)
		})
		// ==================================================
		const input = {
			contentPlanner: this.state.selectedContentPlanner.PK,
			createdAs,
			creatorHandle: '@YouSayEditor',
			creatorName: createdAs,
			contentType: type,
			contentMainCategory: this.state.contentMainCategory,
			creatorUUID: creatorID,
			originalCreator:
				this.state.userDetails && this.state.userDetails.PK
					? this.state.userDetails.PK
					: creatorID,
			type: 'content',
			allowShare: this.state.allowShare,
			createInBoxOffice: this.state.createInBoxOffice,
			allowComments: this.state.allowComments,
			genderSpecific: this.state.selectedGenderType,
			tagsWithGenderTarget: this.state.tagsWithGenderArr,
			peopleValues: this.state.selectedPeopleList,
			syncToYousaytv:
				contentType == 'Story'
					? this.state.syncToWordpress
					: false,
			contentMetaInfo: {
				storyDetails:
					contentType == 'Story' || contentType == 'ShortByte'
						? await this.getStoryData()
						: {},
				coverStoryDetails:
					contentType == 'CoverStory' ? await this.getCoverStoryData() : {},
				mcqDetails: contentType == 'Mcq' ? await this.getMcqData() : {},
				pollDetails: contentType == 'Poll' ? await this.getPollData() : {},
				slideShowDetails:
					contentType == 'SlideShow' ? await this.getSlideShowData(false) : {},
				liveCricketDetails:
					contentType == 'liveCricketScore'
						? await this.getLiveCricketInfo()
						: {},
				cricketPointsTableDetails:
					contentType == 'cricketPointsTable'
						? await this.getPointsTableInfo()
						: {},
				liveNewsSectionDetails:
					contentType == 'liveNews'
						? await this.getLiveNewsData(
							this.liveNews,
							createdAs,
							'Web',
							editContent,
						)
						: {},
			},
			scheduledDate: this.getScheduledDate(),
			scheduledTime: this.getScheduledTime(),
			contentStatus: 'draft',
			contentVersion: 2,
			selectedAutoExpireDate: this.state.selectedAutoExpireDate.value,
			selectedAutoDeleteDate: this.state.selectedAutoDeleteDate.value,
			contentLanguages: [this.state.contentSelectedLangVal],
			targetAreas:
				this.state.contentSelectedLangVal == 'En'
					? ['RestOfIndia', 'TG&AP']
					: ['TG&AP'],
			targetAreaV2,
		}

		if (contentType == 'liveCricketScore' && this.state.matchKey) {
			input.matchKey = this.state.matchKey
		}

		if (contentType == 'liveCricketScore' && this.state.teamsShortCodes) {
			input.teamsShortCodes = this.state.teamsShortCodes
		}

		if (contentType == 'cricketPointsTable' && this.state.tournamentKey) {
			input.tournamentKey = this.state.tournamentKey
		}

		if (contentType == 'cricketPointsTable' && this.state.associationKey) {
			input.associationKey = this.state.associationKey
		}

		if (Object.keys(this.videoDetails).length > 0) {
			input.isContentVideo = true
			input.contentVideoKey = this.videoDetails.contentVideoKey
		} else {
			input.isContentVideo = false
		}

		if (this.contentImage) {
			input.contentMetaInfo.contentImage = this.contentImage.substring(
				this.contentImage.indexOf('public'),
			)
		}

		if (this.contentImage && editContent && !this.props.duplicateContent) {
			input.contentMetaInfo.contentImages = [
				this.contentImage.substring(this.contentImage.indexOf('public')),
			]
		}

		if (!this.props.duplicateContent && editContent) {
			input.PK = contentDetails.PK
			input.SK = contentDetails.SK
			if (
				contentDetails.sendPushNotification != this.state.sendPushNotification
			) {
				input.sendPushNotification = this.state.sendPushNotification
			}

			input.originalCreator = contentDetails.originalCreator
		} else {
			input.creatorName = createdAs
			input.createdAs = createdAs
			input.creatorUUID = creatorID
			input.originalCreator =
				this.state.userDetails && this.state.userDetails.PK
					? this.state.userDetails.PK
					: creatorID

			input.contentID = this.props.duplicateContent
				? this.state.contentID.includes('cont#')
					? this.state.contentID.split('cont#')[1]
					: this.state.contentID
				: this.state.contentID
			input.sendPushNotification = this.state.sendPushNotification
		}

		input.pnPriority = this.state.selectedPnPriority

		input[`pnTitle_${contentSelectedLangVal}`] = this.state.pnTitle
			? this.state.pnTitle.substring(0, 45)
			: ''
		if (this.state.sendPushNotification) {
			input.sendPNWithImage = this.state.sendPNWithImage
				? this.state.sendPNWithImage
				: false
			if (this.state.sendPNWithImage) {
				input[
					`pnDescription_${contentSelectedLangVal}`
				] = this.state.pnDescription
			} else {
				input[
					`bigTextTitle_${contentSelectedLangVal}`
				] = this.state.bigTextTitle
			}
		}

		input[`scheduledTime_${contentSelectedLangVal}`] = this.getScheduledTime()
		input[`scheduledDate_${contentSelectedLangVal}`] = this.getScheduledDate()
		this.state.tagsArr.map((item, index) => {
			input['creatorVideoHashTag' + (index + 1)] = this.appendhashToTag(item)
		})
		this.state.tagsWithTypeArr.map((item, index) => {
			input[
				'creatorVideoHashTag' + (index + 1) + 'AndType'
			] = this.appendhashToTag(item)
		})
		if (this.state.newTagsArr.length > 0) {
			let language = this.state.contentSelectedLangVal
			if (language == 'En') {
				language = 'English'
			} else {
				language = 'Telugu'
			}

			const parameters = {
				UUID: creatorID,
				userHashTags: this.state.newTagsArr,
				tagsLanguage: language,
				// wordPressTagIDs: this.state.WPTagIds,
			}
			console.log(parameters, 'parameters')
			const createTagResponse = await CreateUserHashtag(parameters)
			console.log(createTagResponse, 'CreateUserHashtag response')
		}

		if (this.state.selectedCategory != '') {
			const contentCategories = this.state.selectedCategory.split('->')
			contentCategories.map((item, index) => {
				input['contentCategory' + (index + 1)] = item
			})
		}

		if (
			this.state.isInAppMessage &&
			Object.keys(this.state.inAppMessageDetails).length > 0 &&
			!this.state.stickyPost
		) {
			const inAppMessageDetailsObject = this.state.inAppMessageDetails
			inAppMessageDetailsObject.campaignStartDateTime = Math.floor(
				parseInt(
					new Date(
						this.state.inAppMessageDetails.campaignStartDateTime,
					).getTime(),
				) / 1000,
			)
			inAppMessageDetailsObject.campaignEndDateTime = Math.floor(
				parseInt(
					new Date(this.state.inAppMessageDetails.campaignEndDateTime).getTime(),
				) / 1000,
			)
			input.inAppMessageDetails = this.state.inAppMessageDetails
			input.isInAppMessage = this.state.isInAppMessage
			input.stickyPost = false
			input.isPushRankActive = false
		} else if (this.state.stickyPost) {
			input.isInAppMessage = true
			input.stickyPost = this.state.stickyPost
			if (
				editContent &&
				contentDetails.stickyInProgressDateTime != undefined &&
				contentDetails.stickyInProgressDateTime != null &&
				contentDetails.stickyInProgressDateTime
			) {
				const stickyPublishedDateTime = contentDetails.stickyInProgressDateTime
				const PresentDateTimeStamp = Math.round(new Date().getTime() / 1000)
				const stickyPushEndDateTime =
					parseInt(stickyPublishedDateTime) +
					parseInt(this.state.pushRankUpTo) * 60
				if (PresentDateTimeStamp - stickyPushEndDateTime > 0) {
					input.positionFromTop = this.state.positionFromTop
				} else {
					input.positionFromTop = this.state.pushRankTo
				}
			} else {
				input.positionFromTop =
					this.contentStatus != undefined &&
						this.contentStatus != null &&
						this.contentStatus == 'm#published' &&
						this.isPreviouslyStickyPost != undefined &&
						this.isPreviouslyStickyPost != null &&
						this.isPreviouslyStickyPost
						? parseInt(this.state.positionFromTop)
						: parseInt(this.state.pushRankTo)
			}

			input.tempPositionFromTop = parseInt(this.state.positionFromTop)
			input.showSticky = this.state.showSticky
			if (this.state.showSticky == 'stickyNoOfTimes') {
				input.stickyTargetImpressions = this.state.stickyTargetImpressions
			}

			const stickyEndDateTimeStamp = new Date(
				this.state.stickyEndDateTime,
			).getTime()
			input.stickyEndDateTime = Math.floor(stickyEndDateTimeStamp / 1000)
			input.pushRankUpTo = parseInt(this.state.pushRankUpTo)
			input.pushRankTo = parseInt(this.state.pushRankTo)
			input.isPushRankActive = true
		} else {
			input.stickyPost = false
			input.isPushRankActive = false
			input.isInAppMessage = false
			input.isPushRankActive = false
		}

		if (
			this.state.selectedContentType == 'liveCricketScore' ||
			this.state.selectedContentType == 'cricketPointsTable' ||
			this.state.selectedContentType == 'ShortByte'
		) {
			input.storyType = this.state.selectedContentType
		}

		return input
	}

	closeApproveModal = () => {
		this.setState({ approveCreatedContentModal: false }, () => {
			if (this.props.editContent && !this.props.duplicateContent) {
				this.reloadWindow()
			} else {
				this.goHome()
			}
		})
	}

	reloadWindow = () => {
		window.location.reload()
	}

	goHome = () => {
		window.location.href = window.location.origin
	}

	handleCreateContent = async () => {
		this.setState({ enableCreateContent: false })
		const inputObj = await this.contentInputData(
			this.state.selectedContentType,
		)
		const input = this.stripTypenames(inputObj)
		// create post in wordpress if it is a story type
		const videoUrlExists =
			this.story.coverStoryVideoURL && this.story.coverStoryVideoURL != ''
		const storyLinkDetails =
			this.story.contentNewLinkDetails &&
			this.story.contentNewLinkDetails[0] &&
			this.story.contentNewLinkDetails[0].httpsLink &&
			this.story.contentNewLinkDetails[0].httpsLink != ''
		const { wordPressInfo } = this.state
		const checkLinkAndVideoExists = storyLinkDetails || videoUrlExists
		input.syncToYousaytv = false
		if (
			(this.state.selectedContentType == 'Story') &&
			this.state.syncToWordpress &&
			!this.state.disableSyncToWordPress &&
			!checkLinkAndVideoExists
		) {
			input.syncToYousaytv = true
		}

		wordPressInfo.wordPressPermaLink = this.state.permalink
		const targetAreaCategories = []
		this.state.selectedTargetAreas.map((item, index) => {
			if (item.wordPressCategoryIDs) {
				item.wordPressCategoryIDs.map((catid, catidindex) => {
					targetAreaCategories.push(catid)
				})
			} else {
				targetAreaCategories.push(item.wordPressCategoryID)
			}
		})
		this.state.WPCatIds.map((item, index) => {
			wordPressInfo['wordPressContentCategory' + (index + 1) + 'ID'] = item
		})
		const categoryIds = this.state.WPCatIds
		if (this.state.addNewsToCategory && this.state.newsCategoryId) {
			categoryIds.push(this.state.newsCategoryId)
		}

		if (this.state.addTargetAreasToWP) {
			wordPressInfo.wordPressCategoryIDs = categoryIds.concat(
				targetAreaCategories,
			)
		} else {
			wordPressInfo.wordPressCategoryIDs = categoryIds
		}

		input.wordPressInfo = wordPressInfo
		input.addedTargetAreaCategories = this.state.addTargetAreasToWP
		input.addedNewsCategories = this.state.addNewsToCategory
		input.targetAreaCategoriesArr = targetAreaCategories
		input.newsCategoriesArr = this.state.newsCategoryId

		console.log(input, 'input===========1212')

		if (
			!this.props.duplicateContent &&
			this.props.editContent &&
			!this.props.isNewLang
		) {
			const response = await UpdateContent(input)
			console.log(response, 'response111111===========')
			if (response.statusCode == 'A186') {
				toast.success('Content Updated Successfully', this.toastStyle)
				if (input.SK == 'm#draft') {
					this.setState({
						contentCreated: true,
						approveCreatedContentModal: true,
						createdContentData: input,
					})
				} else {
					setTimeout(() => {
						this.reloadWindow()
					}, 2000)
				}
			} else {
				toast.error('Failed To Update Content', this.toastStyle)
			}
		} else if (
			!this.props.duplicateContent &&
			this.props.editContent &&
			this.props.isNewLang
		) {
			const response = await UpdateContent(input)
			console.log(response, 'response122222===========')
			if (response.statusCode == 'A186') {
				toast.success('Content Created Successfully', this.toastStyle)
				if (input.SK == 'm#draft') {
					this.setState({
						contentCreated: true,
						approveCreatedContentModal: true,
						createdContentData: input,
					})
				} else {
					setTimeout(() => {
						this.reloadWindow()
					}, 2000)
				}
			} else {
				toast.error('Failed To Create Content', this.toastStyle)
			}
		} else {
			const response = await CreateContentService(input)
			console.log(response, 'response===========')
			if (response.statusCode == 'A184') {
				this.setState(
					{
						contentCreated: true,
						approveCreatedContentModal: true,
						createdContentData: input,
					},
					() => {
						if (this.props.duplicateContent) {
							setTimeout(() => {
								this.goHome()
							}, 20000)
						}
					},
				)
				toast.success('Content Created Successfully', this.toastStyle)
				// setTimeout(() => {
				// 	this.reloadWindow()
				// }, 2000)
			} else {
				toast.error('Failed To Create Content', this.toastStyle)
			}
		}
	}

	displayToast = (type, message) => {
		if (type == 'success') {
			toast.success(message, this.toastStyle)
		} else {
			toast.error(message, this.toastStyle)
		}
	}

	stickyPostValidations = () => {
		const {
			stickyPost,
			stickyEndDateTime,
			showSticky,
			stickyTargetImpressions,
			positionFromTop,
			pushRankTo,
			pushRankUpTo,
		} = this.state
		const stickyPostValidation = StickyPostValidations(
			stickyPost,
			stickyEndDateTime,
			showSticky,
			stickyTargetImpressions,
			positionFromTop,
			pushRankTo,
			pushRankUpTo,
		)
		return stickyPostValidation
	}

	inAppMessageValidations = () => {
		const { stickyPost, isInAppMessage, inAppMessageDetails } = this.state
		const inAppMessageValidations = InAppMessageValidations(
			stickyPost,
			isInAppMessage,
			inAppMessageDetails,
		)
		return inAppMessageValidations
	}

	checkDisabled = allMandatoryValidations => {
		const {
			sendPushNotification,
			sendPNWithImage,
			pnTitle,
			bigTextTitle,
			tagsArr,
		} = this.state
		const pnTextValidation = sendPNWithImage
			? pnTitle != ''
			: bigTextTitle != ''
		const sendPnValidation = sendPushNotification ? pnTextValidation : true
		const enableContentValidation = this.state.enableCreateContent
		const PnAndTargetAreasValidation =
			sendPnValidation && this.state.selectedTargetAreas.length > 0
		const stickyPostValidations = this.stickyPostValidations()
		const inAppMessageValidations = this.inAppMessageValidations()
		// to extract and return missing validations fields, sending allMandatoryValidations prop
		if (allMandatoryValidations) {
			return {
				// [`GeneralOption: hashTags`]: tagsArr != undefined && tagsArr.length > 0 ? true : false,
				'GeneralOption: targetAreas':
					this.state.selectedTargetAreas.length > 0,
				'GeneralOption: category': Boolean(this.state.selectedCategory),
				'GeneralOption: sendPnValidation': sendPnValidation,
				'GeneralOption: stickyPostValidations': stickyPostValidations,
				'GeneralOption: inAppMessageValidations': inAppMessageValidations,
			}
		}

		return !(enableContentValidation &&
			PnAndTargetAreasValidation &&
			stickyPostValidations &&
			inAppMessageValidations &&
			this.state.selectedCategory)
	}

	displayMandatoryValidations = data => {
		const allMandatoryValidations = true
		const generalAndOtherOptionValidations = this.checkDisabled(
			allMandatoryValidations,
		)
		const totalContentMissingFieldsObj = {
			...generalAndOtherOptionValidations,
			...data,
		}
		const totalContentMissingFields = Object.keys(
			totalContentMissingFieldsObj,
		)?.filter(key => totalContentMissingFieldsObj[key] == false)
		return totalContentMissingFields.length ? (
			<MandatoryValidations
				totalContentMissingFields={totalContentMissingFields}
			/>
		) : null
	}

	storyMandatoryValidations = allMandatoryValidations => {
		const data = this.storyValidations(this.story, allMandatoryValidations)
		return this.displayMandatoryValidations(data)
	}

	liveNewsMandatoryValidations = allMandatoryValidations => {
		const data = this.liveNewsValidations(
			this.liveNews,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	flipToStoryMandatoryValidataion = allMandatoryValidations => {
		const data = this.flipToStoryValidataion(
			this.coverStory.flipToStoryDetails,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	onlyCoverMandatoryValidataion = allMandatoryValidations => {
		const fromSlideshow = false
		const data = this.onlyCoverValidataion(
			this.coverStory.onlyCoverDetails,
			fromSlideshow,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	inAppBrowserMandatoryValidataion = allMandatoryValidations => {
		const data = this.inAppBrowserValidataion(
			this.coverStory.inAppBrowserDetails,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	mcqMandatoryValidations = allMandatoryValidations => {
		const data = this.mcqValidations(this.mcq, allMandatoryValidations)
		return this.displayMandatoryValidations(data)
	}

	slideShowMandatoryValidations = allMandatoryValidations => {
		const data = this.slideShowValidations(
			this.slideShow,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	pollMandatoryValidations = allMandatoryValidations => {
		const data = this.pollValidations(this.poll, allMandatoryValidations)
		return this.displayMandatoryValidations(data)
	}

	liveCricketScoreMandatoryValidations = allMandatoryValidations => {
		const data = this.liveCricketScoreValidations(
			this.liveCricket,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	cricketPointsTableMandatoryValidations = allMandatoryValidations => {
		const data = this.cricketPointsTableValidations(
			this.cricketPointsTable,
			allMandatoryValidations,
		)
		return this.displayMandatoryValidations(data)
	}

	renderContentMandatoryValidations = () => {
		const allMandatoryValidations = true
		const { selectedContentType } = this.state
		if (selectedContentType == 'Story' || selectedContentType == 'ShortByte') {
			return this.storyMandatoryValidations(allMandatoryValidations)
		}

		if (selectedContentType == 'CoverStory') {
			return this.coverStorySubType == 'FlipToStory'
				? this.flipToStoryMandatoryValidataion(allMandatoryValidations)
				: this.coverStorySubType == 'OnlyCover'
					? this.onlyCoverMandatoryValidataion(allMandatoryValidations)
					: this.coverStorySubType == 'InAppBrowser'
						? this.inAppBrowserMandatoryValidataion(allMandatoryValidations)
						: false
		}

		if (selectedContentType == 'Mcq') {
			return this.mcqMandatoryValidations(allMandatoryValidations)
		}

		if (selectedContentType == 'SlideShow') {
			return this.slideShowMandatoryValidations(allMandatoryValidations)
		}

		if (selectedContentType == 'Poll') {
			return this.pollMandatoryValidations(allMandatoryValidations)
		}

		if (selectedContentType == 'liveCricketScore') {
			return this.liveCricketScoreMandatoryValidations(allMandatoryValidations)
		}

		if (selectedContentType == 'cricketPointsTable') {
			return this.cricketPointsTableMandatoryValidations(
				allMandatoryValidations,
			)
		}

		if (selectedContentType == 'liveNews') {
			return this.liveNewsMandatoryValidations(allMandatoryValidations)
		}

		return false
	}

	preview = async () => {
		const data = await this.previewInputData(this.state.selectedContentType)
		this.setState({
			previewData: data,
		})
	}

	GetDate = () => (
		String(new Date().getFullYear()) +
		('0' + (new Date().getMonth() + 1)).slice(-2) +
		('0' + new Date().getDate()).slice(-2)
	)

	resetDataAndChangeType = () => {
		this.resetGeneralOption()
		this.story = {}
		this.coverStory = {
			flipToStoryDetails: {},
			onlyCoverDetails: {},
			inAppBrowserDetails: {},
		}
		this.mcq = {}
		this.videoDetails = {}
		this.poll = {}
		this.liveNews = []
		this.setState({
			modalVisible: !this.state.modalVisible,
			selectedContentType: this.state.changeToType,
			enableCreateContent: false,
			contentSelectedLangVal: this.state.changeToLanguage,
		})
	}

	resetCoverStoryContent = () => {
		this.coverStory = {
			flipToStoryDetails: {},
			onlyCoverDetails: {},
			inAppBrowserDetails: {},
		}
		this.setState({
			enableCreateContent: false,
		})
	}

	removeImage = index => {
		const filteredArr = this.state.imagePreviewUrl.filter(
			(item, imageindex) => imageindex != index,
		)
		const filesArr = this.state.files.filter((item, fileIndex) => fileIndex != index)
		this.setState({ imagePreviewUrl: filteredArr, files: filesArr })
	}

	geteditcontentStoryData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.storyDetails
		: {}

	geteditcontentCoverStoryData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.coverStoryDetails
		: {}

	geteditcontentMCQData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.mcqDetails
		: {}

	geteditcontentPollData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.pollDetails
		: {}

	geteditcontentSlideShowData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.slideShowDetails
		: {}

	getEditContentLiveCricketDetails = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.liveCricketDetails
		: {}

	getEditContentLiveNewsData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.liveNewsSectionDetails
		: {}

	getEditcontentPointsTableData = props => props.contentDetails && props.contentDetails.contentMetaInfo
		? props.contentDetails.contentMetaInfo.cricketPointsTableDetails
		: {}

	renderSubContent = contentType => {
		const {
			mcq,
			story,
			coverStory,
			slideShow,
			poll,
			liveCricket,
			cricketPointsTable,
			liveNews,
		} = this
		const contentSelectedLangVal = this.props.contentSelectedLangVal
			? this.props.contentSelectedLangVal
			: this.state.contentSelectedLangVal

		const editcontentStoryData =
			this.props.contentDetails && this.props.contentDetails.contentMetaInfo
				? this.getStoryContentData(
					this.props.contentDetails.contentMetaInfo.storyDetails,
				)
				: {}

		const editcontentCoverStoryData = this.geteditcontentCoverStoryData(
			this.props,
		)
		const editcontentMCQData = this.geteditcontentMCQData(this.props)
		const editcontentSlideShowData = this.geteditcontentSlideShowData(
			this.props,
		)
		const editcontentPollData = this.geteditcontentPollData(this.props)
		const editcontentLiveCricketData = this.getEditContentLiveCricketDetails(
			this.props,
		)
		const editcontentPointsTableData = this.getEditcontentPointsTableData(
			this.props,
		)
		const editcontentLiveNewsData = this.getEditContentLiveNewsData(this.props)

		const editContent = this.props.editContent ? this.props.editContent : false

		switch (contentType) {
			case 'Mcq':
				return (
					<McqContent
						editContent={editContent}
						mcqDetails={editContent ? editcontentMCQData : mcq}
						updateInParent={this.updateInParent}
						contentSelectedLangVal={contentSelectedLangVal}
					/>
				)
			case 'ShortByte':
			case 'Story':
				return (
					<StoryDetails
						selectedContentType={this.state.selectedContentType}
						duplicateContent={this.props.duplicateContent}
						syncToWordpressValue={this.state.syncToWordpress}
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						setFeaturedImageId={this.setFeaturedImageId}
						storyDetails={editContent ? editcontentStoryData : story}
						updateInParent={this.updateInParent}
						editContent={editContent}
						contentSelectedLangVal={contentSelectedLangVal}
						updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
					/>
				)
			case 'liveCricketScore':
				return (
					<LiveUpdates
						SK={editContent ? this.props.contentDetails.SK : ''}
						matchKey={editContent ? this.props.contentDetails.matchKey : ''}
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						handleFeaturedMatchKey={this.handleFeaturedMatchKey}
						handleTeamsShortCodes={this.handleTeamsShortCodes}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						setFeaturedImageId={this.setFeaturedImageId}
						liveCricketDetails={
							editContent ? editcontentLiveCricketData : liveCricket
						}
						updateInParent={this.updateInParent}
						editContent={editContent}
						contentSelectedLangVal={contentSelectedLangVal}
						updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
						handleSelectedTournament={this.handleSelectedTournament}
						handleSelectedAssociation={this.handleSelectedAssociation}
					/>
				)
			case 'cricketPointsTable':
				return (
					<PointsTable
						tournamentKey={
							editContent ? this.props.contentDetails.tournamentKey : ''
						}
						associationKey={
							editContent ? this.props.contentDetails.associationKey : ''
						}
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						handleSelectedTournament={this.handleSelectedTournament}
						handleSelectedAssociation={this.handleSelectedAssociation}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						setFeaturedImageId={this.setFeaturedImageId}
						cricketPointsTableDetails={
							editContent ? editcontentPointsTableData : this.cricketPointsTable
						}
						updateInParent={this.updateInParent}
						editContent={editContent}
						contentSelectedLangVal={contentSelectedLangVal}
						updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
					/>
				)

			case 'CoverStory':
				return (
					<CoverStoryDetails
						coverStoryDetails={
							editContent ? editcontentCoverStoryData : coverStory
						}
						updateInParent={this.updateInParent}
						editContent={editContent}
						resetCoverStoryContent={this.resetCoverStoryContent}
						contentSelectedLangVal={contentSelectedLangVal}
						updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
					/>
				)
			case 'SlideShow':
				return (
					<SlideShowContent
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						setFeaturedImageId={this.setFeaturedImageId}
						slideShowDetails={
							editContent ? editcontentSlideShowData : slideShow
						}
						updateInParent={this.updateInParent}
						contentSelectedLangVal={contentSelectedLangVal}
						editContent={editContent}
						updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
					/>
				)
			case 'Poll':
				return (
					<PollContent
						pollDetails={editContent ? editcontentPollData : poll}
						editContent={editContent}
						updateInParent={this.updateInParent}
						contentSelectedLangVal={contentSelectedLangVal}
					/>
				)
			case 'liveNews':
				return (
					<LiveNewsDetails
						//   duplicateContent={this.props.duplicateContent}
						syncToWordpressValue={false}
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						setFeaturedImageId={this.setFeaturedImageId}
						liveNewsSectionDetails={
							editContent ? editcontentLiveNewsData : liveNews
						}
						selectedContentType={this.state.selectedContentType}
						updateInParent={this.updateInParent}
						editContent={editContent}
						contentSelectedLangVal={contentSelectedLangVal}
						//   updateVideodetails={this.updateVideodetails}
						contentID={this.state.contentID}
					/>
				)

			default:
				return <div></div>
		}
	}

	handleChangeSendPNWith = () => {
		this.setState({ sendPNWithImage: !this.state.sendPNWithImage })
	}

	handleChangeStickyPositionFromTop = positionFromTop => {
		this.setState({
			positionFromTop,
		})
	}

	handleChangeShowStickyOption = showSticky => {
		this.setState({
			showSticky,
		})
	}

	handleChangeStickyNoOfTimes = stickyTargetImpressions => {
		this.setState({
			stickyTargetImpressions,
		})
	}

	handleChangeStickyEndDateTime = stickyEndDateTime => {
		this.setState({
			stickyEndDateTime,
		})
	}

	handleChangeInAppMessageSwitch = e => {
		this.setState(
			{
				isInAppMessage: e.target.checked,
				createInBoxOffice: !e.target.checked,
			},
			() => {
				if (this.state.isInAppMessage) {
					this.handleAutoExpire(this.state.autoExpireOptions[0])
					this.handleAutoDelete(this.state.autoExpireOptions[0])
				}
			},
		)
	}

	updateInAppMessageDetails = inAppMessageDetails => {
		this.setState({
			inAppMessageDetails,
		})
	}

	handleChangePushRankUpTo = pushRankUpTo => {
		this.setState({
			pushRankUpTo,
		})
	}

	handleChangePushRankTo = pushRankTo => {
		this.setState({
			pushRankTo,
		})
	}

	hasPositionFromTopError = () => !this.state.positionFromTop

	hasPushRankToError = () => !this.state.pushRankTo

	hasPushRankUpToError = () => !this.state.pushRankUpTo

	hasStickyNumberOfTimesError = () => !this.state.stickyTargetImpressions

	render() {
		const {
			contentTypeOptions,
			selectedContentType,
			selectedContributor,
			modalVisible,
			contentModalVisible,
			contentLanguageOptions,
			contentSelectedLangVal,
		} = this.state
		const selectedType = this.props.editContent
			? this.props.contentDetails.storyType &&
				this.props.contentDetails.storyType != ''
				? this.props.contentDetails.storyType
				: this.props.contentDetails.contentType
			: selectedContentType

		return (
			<div className=' row col-md-12'>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>

				{this.state.creationStatus == 'Success' ? (
					<Alert variant='success'>
						<p>Content Created Successfully</p>
					</Alert>
				) : null}
				{this.state.creationStatus == 'Failed' ? (
					<Alert variant='danger'>
						<p>Failed To Create Content</p>
					</Alert>
				) : null}

				<div
					className='col-md-7'
					style={{
						borderStyle: 'solid',
					}}
				>
					<Modal
						show={contentModalVisible}
						onHide={() => this.setState({ contentModalVisible: false })}
					>
						<Modal.Body>Cannot Change Type in Edit</Modal.Body>
						<Modal.Footer>
							<Button
								onClick={() => this.setState({ contentModalVisible: false })}
							>
								Ok
							</Button>
						</Modal.Footer>
					</Modal>
					<Modal show={modalVisible} onHide={() => this.handleModal()}>
						<Modal.Body>All The Changes Will Be Discarded</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.handleModal()}>Cancel</Button>
							<Button onClick={() => this.resetDataAndChangeType()}>Ok</Button>
						</Modal.Footer>
					</Modal>
					<div>
						<label htmlFor='text'>Choose Content Type</label>
					</div>
					<div className='row'>
						{contentTypeOptions.map((item, index) => (
							<div className='col-md-4' key={index}>
								<input
									id={item.item}
									value={selectedContentType}
									type='radio'
									checked={this.state.selectedContentType == item.item}
									onChange={() => {
										this.changeContentType(
											this.state.selectedContentType,
											item.item,
										)
									}}
								></input>
								<text htmlFor={item.item}>{item.item}</text>
							</div>
						))}
					</div>

					{!this.props.editContent ? (
						<div>
							<div>
								<label htmlFor='text'>Choose Content Language</label>
							</div>
							<div className='row'>
								{contentLanguageOptions.map((item, index) => (
									<div className='col-md-3' key={index}>
										<input
											value={contentSelectedLangVal}
											type='radio'
											checked={this.state.contentSelectedLangVal == item.value}
											onChange={() => {
												this.changeContentLanguage(
													this.state.contentSelectedLangVal,
													item.value,
												)
											}}
										></input>
										<text htmlFor={item.label}>{item.label}</text>
									</div>
								))}
							</div>
						</div>
					) : (
						<div>
							<div>
								<label htmlFor='text'>Select Content Language</label>
							</div>
							<div className='row'>
								<text htmlFor={this.props.contentSelectedLangVal}>
									{this.props.contentSelectedLangVal}
								</text>
							</div>
						</div>
					)}
					<div className='row col-md-9'>
						<CreateAs
							data={this.state}
							handleCreateAs={this.handleCreateAs}
							handleSelectContributor={this.handleSelectContributor}
							handleSelectContentPlanner={this.handleSelectContentPlanner}
						/>
					</div>
					<div className='row col-md-12'>
						<GeneralOptions
							editContent={this.props.editContent}
							data={this.state}
							// updateNewsCategoryId={this.updateNewsCategoryId}
							handleSelectedPeopleList={this.handleSelectedPeopleList}
							handlePnPriority={this.handlePnPriority}
							setItemSelected={this.setItemSelected}
							handleSendNotification={this.handleSendNotification}
							handleOnChangeHashTag={this.handleOnChangeHashTag}
							handleSuggestionClick={this.handleSuggestionClick}
							removeTag={this.removeTag}
							handleGenderTarget={this.handleGenderTarget}
							handleAllowShare={this.handleAllowShare}
							handleAllowDownloads={this.handleAllowDownloads}
							handleCreateInBoxOffice={this.handleCreateInBoxOffice}
							handleAllowComments={this.handleAllowComments}
							setStartDate={this.setStartDate}
							setPollClosingDate={this.setPollClosingDate}
							handleMainCategory={this.handleMainCategory}
							handleAutoExpire={this.handleAutoExpire}
							handleAutoDelete={this.handleAutoDelete}
							togglePNWithBigText={this.togglePNWithBigText}
							handleChangeSendPNWith={this.handleChangeSendPNWith}
							handlebigTextTitle={this.handlebigTextTitle}
							handlePNTitle={this.handlePNTitle}
							handlePNDescription={this.handlePNDescription}
							handleTargetAreas={this.handleTargetAreas}
							handleChangeStickyPost={this.handleChangeStickyPost}
							handleChangeStickyPositionFromTop={
								this.handleChangeStickyPositionFromTop
							}
							handleChangeShowStickyOption={this.handleChangeShowStickyOption}
							handleChangeStickyNoOfTimes={this.handleChangeStickyNoOfTimes}
							handleChangeStickyEndDateTime={this.handleChangeStickyEndDateTime}
							contentStatus={this.contentStatus}
							isPreviouslyStickyPost={this.isPreviouslyStickyPost}
							handleChangePushRankUpTo={this.handleChangePushRankUpTo}
							handleChangePushRankTo={this.handleChangePushRankTo}
							hasPositionFromTopError={this.hasPositionFromTopError}
							hasPushRankToError={this.hasPushRankToError}
							hasPushRankUpToError={this.hasPushRankUpToError}
							hasStickyNumberOfTimesError={this.hasStickyNumberOfTimesError}
						/>
					</div>
					{!this.state.stickyPost ? (
						<div className='row col-md-9'>
							<InAppMessage
								ref={this.InAppMessageChild}
								updateInAppMessageDetails={this.updateInAppMessageDetails}
								inAppMessageDetails={this.state.inAppMessageDetails}
								scheduleDate={this.state.scheduledDate}
								contentStatus={this.contentStatus}
								isPreviouslyCampaign={this.isPreviouslyCampaign}
								handleChangeInAppMessageSwitch={
									this.handleChangeInAppMessageSwitch
								}
								key={this.state.isInAppMessage}
								isInAppMessage={this.state.isInAppMessage}
							/>
						</div>
					) : null}
					{this.renderSubContent(selectedType)}
					{this.renderContentMandatoryValidations()}
					{!this.checkDisabled(false) ? (
						<div className='row'>
							{this.props.editContent ? (
								<div className='col-md-4'>
									<Button
										onClick={() => this.handleCreateContent()}
										variant='primary'
									>
										{this.props.duplicateContent
											? 'Create Content'
											: 'Update Content'}
									</Button>
								</div>
							) : (
								<div className='col-md-4'>
									<Button
										onClick={() => this.handleCreateContent()}
										variant='primary'
									>
										Create Content
									</Button>
								</div>
							)}
							<div className='col-md-4'>
								<Button onClick={() => this.preview()} variant='primary'>
									Preview
								</Button>
							</div>
						</div>
					) : (
						<div className='row'>
							{this.props.editContent ? (
								<div className='col-md-4'>
									<Button disabled variant='secondary'>
										{this.props.duplicateContent
											? 'Create Content'
											: 'Update Content'}
									</Button>
								</div>
							) : (
								<div className='col-md-4'>
									<Button disabled variant='secondary'>
										Create Content
									</Button>
								</div>
							)}
							<div className='col-md-4'>
								<Button disabled variant='secondary'>
									Preview
								</Button>
							</div>
						</div>
					)}
				</div>
				<div className='col-md-1'></div>
				{this.state.contentCreated ? (
					<Modal
						show={this.state.approveCreatedContentModal}
						onHide={() => this.closeApproveModal()}
					>
						<Modal.Header>
							<label>Approve Content</label>
						</Modal.Header>
						<Modal.Body>
							<ApproveCreatedContent
								duplicateContent={this.props.duplicateContent}
								loggedInUserId={this.state.loggedInUserId}
								displayToast={this.displayToast}
								data={this.state.createdContentData}
								contentSelectedLangVal={contentSelectedLangVal}
							/>
						</Modal.Body>
					</Modal>
				) : null}
				{!this.state.contentCreated ? (
					<div className='col-md-4'>
						<div style={{ height: heightPercentageToDP('100%') }}>
							<div
								style={{
									height: heightPercentageToDP('101%'),
									width: widthPercentageToDP('100%'),
									borderStyle: 'solid',
									position: 'relative',
								}}
							>
								{this.state.previewData ? (
									<Preview
										data={this.state.previewData}
										createAs={this.state.createAs}
										selectedContributor={selectedContributor}
										contentSelectedLangVal={contentSelectedLangVal}
									/>
								) : (
									<p
										style={{
											textAlign: 'center',
											marginTop: heightPercentageToDP('45%'),
										}}
									>
										Preview here
									</p>
								)}
							</div>
						</div>
					</div>
				) : null}
			</div>
		)
	}
}
export default withRouter(Content)
